import React, { useState, useEffect, useRef } from "react";
import logo from "../../assets/img/gkt_final_logo.png";
import "../../scss/flag-sprite.css";
import { useHistory } from "react-router-dom";
import tableFilterIcon from "../../assets/img/table-filter-icon.png";
// import CSmartTable from '@coreui/react-pro/src/components/smart-table/CSmartTable';
// import { CSmartTable, CBadge, CButton, CCollapse, CCardBody } from '@coreui/react-pro-pro';
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import PlansBasedOnCountryService from "../../Services/PlansBasedOnCountryService";
import PlansBasedOnRegionService from "../../Services/PlansBasedOnRegionService ";
import RegionListService from "../../Services/RegionService";
import MultiRangeSlider from "multi-range-slider-react";
import AlertPopup from "../Alert_Popup/AlertPopup";
import UserVarificationService from "../../Services/UserVarificationService";
import ContactUsForm from "../Common/ContactUsForm";
import GlobalPlansService from "../../Services/GlobalPlansService";

import CustomModal from "../Kiosk/components/CustomModal";

import t20Wc1 from "../../assets/img/mapicons/t20-wc-1.jpg";
import t20Wc2 from "../../assets/img/mapicons/t20-wc-2.jpg";
import useScrollToTop from "../custom_hooks/useScrollToTop";
import { Helmet } from "react-helmet";
import Loader from "../Alert_Popup/Loader";
import NotFound from "../Common/NotFound";

import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import star from "../../assets/img/stars.png";
import advtSticker from "../../assets/elements/top-up-sticker.png";
import PlansTray from "../Main/Destinations/PlansTray";
import ModalPopup from "../Common/ModalPopup";
import {
  CALLS_AND_SMS,
  NETWORK3_VENDOR,
  RECURRING_BUNDLE_ID,
  DATA_CALLS_SMS,
  DATA_ONLY,
  MAYA_VENDOR,
  PLAN_TYPE_GLOBAL,
  PLAN_TYPE_LOCAL,
  PLAN_TYPE_REGIONAL,
} from "../../Common/Constant";
import googlePlay from "../../assets/img/googleplay.png";
import appStore from "../../assets/img/appstore.png";
import { Tabs } from "../Common/Tabs";
import LocalESim from "../Main/Destinations/LocalESim";
import RegionalESim from "../Main/Destinations/RegionalESim";
import GlobalESim from "../Main/Destinations/GlobalESim";
import Tooltip from "../Common/Tooltip/ToolTip";
import { BsInfoCircleFill } from "react-icons/bs";
import { IoMdArrowDropdown } from "react-icons/io";
import { SlClose } from "react-icons/sl";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import {
  CSmartTable,
  CButton,
  CCollapse,
  CCardBody,
  CAvatar,
  CBadge,
} from "@coreui/react-pro";
import { FiFilter } from "react-icons/fi";
import axios from "axios";
import Australia from "../../assets/img/mapicons/Australia.png";
import Asia from "../../assets/img/mapicons/Asia.png";
import Africa from "../../assets/img/mapicons/Africa.png";
import Balkans from "../../assets/img/mapicons/Balkans.png";
import Caribbean from "../../assets/img/mapicons/Caribbean.png";
import Caucasus from "../../assets/img/mapicons/Caucasus.png";
import LatinAmerica from "../../assets/img/mapicons/LatinAmerica.png";
import MiddleEast from "../../assets/img/mapicons/MiddleEast.png";
import World from "../../assets/img/mapicons/World.png";
import t20WcIcon from "../../assets/img/mapicons/t20-wc-icon.jpg";

// import LocalESim from "./Destinations/LocalESim";
// import RegionalESim from "./Destinations/RegionalESim";
// import GlobalESim from "./Destinations/GlobalESim";
const CustomFilterSection = (props) => {
  const [openTray, setOpenTray] = useState(false);
  const filterBtnRef = useRef();
  // filterBtnRef

  const [activeFilterItem, setActiveFilterItem] = useState(null);

  const handleFilterClick = (index) => {
    setActiveFilterItem((prevActiveItem) =>
      prevActiveItem === index ? null : index
    );
    if (index === 0 && index !== activeFilterItem) {
      props.onCheapestFilterClick();
    } else if (index === 1 && index !== activeFilterItem) {
      props.onBestPricePerGBFilterClick();
    } else if (index === 2 && index !== activeFilterItem) {
      props.onLargestGBFilterClick();
    } else if (index === 3 && index !== activeFilterItem) {
      props.onLongestValidityFilterClick();
    } else {
      props.onFilterRemoveForOthers();
    }

    // if(index===3 && index!==activeFilterItem){
    //   }else{
    //     props.onFilterRemove();
    //   }
  };

  const unlimitedToggle = () => {
    props.onUnlimitedToggle();
    if (props.unlimitedFilter !== true) {
      props.onUnlimitedFilterToggle();
      setActiveFilterItem(null);
      clearFilter();
      // props.onFilterRemoveForOthers();
    } else {
      props.onFilterRemove();
      setActiveFilterItem(null);
      clearFilter();
    }
  };

  // const handleUnlimitedFilterClick = () => {
  //  if(unlimitedFilter === true){
  //   props.onUnlimitedFilterToggle()
  //  }
  // }

  const filterListItems = [
    "Cheapest",
    "Best price/GB",
    "Largest GB",
    "Longest Validity",
  ];

  // Size Filter
  const [minValue, setMinValue] = useState(0);
  const [maxValue, setMaxValue] = useState(200);
  const handleInput = (e) => {
    setMinValue(e.minValue);
    setMaxValue(e.maxValue);
  };

  // Validity Filter
  const [minValidityValue, setMinValidityValue] = useState(0);
  const [maxValidityValue, setMaxValidityValue] = useState(365);
  const handleValidityInput = (e) => {
    setMinValidityValue(e.minValue);
    setMaxValidityValue(e.maxValue);
  };

  // Price Filter
  const [minPriceValue, setMinPriceValue] = useState(0);
  const [maxPriceValue, setMaxPriceValue] = useState(300);
  const handlePriceInput = (e) => {
    setMinPriceValue(e.minValue);
    setMaxPriceValue(e.maxValue);
  };

  const handleFilterChange = () => {
    // Pass all the filter values as an object to the onFilterChange prop
    props.onFilterChange({
      minValue,
      maxValue,
      minValidityValue,
      maxValidityValue,
      minPriceValue,
      maxPriceValue,
    });
  };

  // Open filter Tray
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef();
  const divRef = useRef();

  const handleButtonClick = () => {
    setIsOpen((prevIsOpen) => !prevIsOpen);
  };

  const handleOutsideClick = (event) => {
    if (
      buttonRef.current &&
      !buttonRef.current.contains(event.target) &&
      divRef.current &&
      !divRef.current.contains(event.target)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const clearFilter = () => {
    setMinValue(0);
    setMaxValue(200);
    setMinValidityValue(0);
    setMaxValidityValue(365);
    setMinPriceValue(0);
    setMaxPriceValue(300);
  };

  return (
    <div className="table-filter-section m-0">
      <div
        style={{ gap: "20px" }}
        className="w-100 d-flex flex-wrap justify-content-between align-items-center mb-3"
      >
        <div className="filter-tabs">
          {filterListItems.map((item, index) => (
            // <li
            //   key={index}
            //   className={index === activeFilterItem ? "tab-active" : ""}
            //   ref={filterBtnRef}
            //   onClick={() => handleFilterClick(index)}
            // >
            //   {item}
            // </li>
            <button
              key={index}
              className={`${index === activeFilterItem ? "tab-active" : ""
                } notranslate`}
              ref={filterBtnRef}
              onClick={() => handleFilterClick(index)}
            >
              {item}
            </button>
          ))}
        </div>
        <div
          className={`${props.unlimitedFilter ? "unlimited-active" : ""
            } unlimited-filter d-flex justify-content-start align-items-start`}
          onClick={unlimitedToggle}
        >
          <button
            className="toggle-switch notranslate"
            aria-label="Toggle Light Mode"
          >
            <span></span>
            <span></span>
          </button>
          <p className="m-0 ml-2">Unlimited plans</p>
        </div>
      </div>
      <div
        style={{ gap: "20px" }}
        className="w-100 d-flex flex-wrap justify-content-between align-items-center mb-3"
      >
        <div className="search-filter">
          <label htmlFor="">Search: </label>
          <input
            type="text"
            placeholder=""
            value={props.searchText}
            onChange={props.handleSearchChange}
          />
        </div>
        <div className="">
          <button
            ref={buttonRef}
            onClick={handleButtonClick}
            className="filter-btn notranslate text-white"
            style={{background:"#d81b60"}}
          >
            Filter
            <FiFilter className="ml-1" />
          </button>
          {isOpen && (
            <div ref={divRef} className="filter-btn-tray-section">
              <div className="size-filter mb-2">
                <label htmlFor="">Size:</label>
                <span>
                  {minValue}GB - {maxValue}GB
                </span>
                <MultiRangeSlider
                  className="multiRangeSlider"
                  min={0}
                  max={200}
                  // step={5}
                  minValue={minValue}
                  maxValue={maxValue}
                  onInput={(e) => {
                    handleInput(e);
                    handleFilterChange();
                    // props.onFilterChange({ minValue, maxValue, minValidityValue, maxValidityValue, minPriceValue, maxPriceValue });
                  }}
                />
              </div>
              <div className="size-filter mb-2">
                <label htmlFor="">Validity:</label>
                <span>
                  {minValidityValue}D - {maxValidityValue}D
                </span>
                <MultiRangeSlider
                  min={0}
                  max={365}
                  // step={5}
                  minValue={minValidityValue}
                  maxValue={maxValidityValue}
                  onInput={(e) => {
                    handleValidityInput(e);
                    handleFilterChange();
                    // props.onFilterChange({ minValue, maxValue, minValidityValue, maxValidityValue, minPriceValue, maxPriceValue });
                  }}
                />
              </div>
              <div className="size-filter mb-2">
                <label htmlFor="">Price:</label>
                <span>
                  £{minPriceValue} - £{maxPriceValue}
                </span>
                <MultiRangeSlider
                  min={0}
                  max={300}
                  // step={5}
                  minValue={minPriceValue}
                  maxValue={maxPriceValue}
                  onInput={(e) => {
                    handlePriceInput(e);
                    handleFilterChange();
                    // props.onFilterChange({ minValue, maxValue, minValidityValue, maxValidityValue, minPriceValue, maxPriceValue });
                  }}
                />
              </div>
              <div className="d-flex justify-content-end align-items-center mt-3">
                <button
                  onClick={clearFilter}
                  className="btn btn-dark btn-sm notranslate"
                  style={{background:"#d81b60"}}
                >
                  clear
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
const options = [
  { value: 1, label: "Local" },
  { value: 2, label: "Regional" },
  { value: 3, label: "Global" },
];
const Plans = (props) => {
  useScrollToTop();
  const [icon, setIcon] = useState(false);
  const [buy, setBuy] = useState(false);
  const [regionId, setRegionId] = useState();
  const [alpha2, setAlpha2] = useState();
  const [premium, setPremium] = useState([{}]);
  const [popular, setPopular] = useState([{}]);
  const [unlimited, setUnlimited] = useState([{}]);
  const [country, setCountry] = useState();
  const [countryOrRegion, setCountryOrRegion] = useState();
  const [message, setMessage] = useState();
  const [plansFound, setPlansFound] = useState(false);
  const [userPlans, setUserPlans] = useState([{}]);
  const [countryBg, setCountryBg] = useState();
  const [detailsState, setDetailsState] = useState([]);
  const [buyDetailsState, setBuyDetailsState] = useState([]);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [currentDetails, setCurrentDetails] = useState({});
  const [showPlansTray, setShowPlansTray] = useState(false);
  const [recurringModal, setRecurringModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [subPlan, setSubPlan] = useState(null);
  const [showeKycPopup, setShoweKycPopup] = useState(false);
  const [tabsActive, setTabsActive] = useState(true);
  const [suggestionRegionPlanPage, setSuggestionRegionPlanPage] = useState();
  // const [tabsActive, setTabsActive] = useState(true);
  const [suggestionGlobalPlanPage, setSuggestionGlobalPlanPage] = useState();
  //for search
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [dummy, setDummy] = useState();
  const [userInput, setUserInput] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [regions, setRegions] = useState([]);
  const [countries, setCountries] = useState([]);
  const [europeItems, setEuropeItems] = useState([]);
  const [asiaItems, setAsiaItems] = useState([]);
  const [africaItems, setAfricaItems] = useState([]);
  const [americasItems, setAmericasItems] = useState([]);
  const [oceaniaItems, setOceaniaItems] = useState([]);
  const [countryBasedOnRegion, setCountrybasedOnRegion] = useState([]);
  const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(0);
  const history = useHistory();
  const [selectedSuggestion, setSelectedSuggestion] = useState(null);
  const [filteredPlans, setFilteredPlans] = useState([]);
  const [plan, setPlan] = useState([]);

  const [searchText, setSearchText] = useState("");
  const [isValidSuggestion, setIsValidSuggestion] = useState(true);
  const [showLogin, setShowLoginPopUp] = useState(false);
  const [showVerifyPopup, setShowVerifyPopup] = useState(false);
  const [unlimitedOrOther, setUnlimitedOrOther] = useState([{}]);
  const [randomplans2, setRandomPlans2] = useState();
  const [isLoading, setIsLoading] = useState(false);

  // Meta tag info
  const [metaTagInfo, setMetaTagInfo] = useState({});
  const [planPageCountry, setPlanPageCountry] = useState();
  const [planPageRegion, setPlanPageRegion] = useState();
  const [metaDataRegion, setMetaDataRegion] = useState([]);
  const [metaDataCountry, setMetaDataCountry] = useState([]);

  const [suggestionCountryPlanPage, setSuggestionCountryPlanPage] = useState();
  const [indicatoPosition, setIndicatoPosition] = useState(0);
  const [currentTab, setCurrentTab] = useState({
    value: 1,
    label: "Local eSIM",
  });
  const [currentTabWidth, setCurrentTabWidth] = useState(0);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [globalCountries, setGlobalCountries] = useState("");
  const [isCoverageDropdownOpen, setIsCoverageDropdownOpen] = useState(false);
  const [globalCountryTicketIndex, setGlobalCountryTicketIndex] = useState();
  const [countryTicketIndex, setCountryTicketIndex] = useState();
  const [globalCountry, setGlobalCountry] = useState([]);
  const [resetTheFilterValue, setResetTheFilterValue] = useState(false);
  // const [isCoverageDropdownOpen, setIsCoverageDropdownOpen] = useState(false);
  const detailsCoverageDropdownRef = useRef(null);
  const [
    isCoverageDropdownOpenForDetails,
    setIsCoverageDropdownOpenForDetails,
  ] = useState(false);
  const [indexForDetailsDropdown, setIndexForDetailsDropdown] = useState(null);
  const location = useLocation();
  const [countryInfo, setCountryInfo] = useState({});
  const [countryInfoError, setCountryInfoError] = useState("");
  const [imageLoaded, setImageLoaded] = useState(false);
  const [regionInfo, setRegionInfo] = useState("");

  // States end here

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, [50]);
  }, []);

  useEffect(() => {
    if (location.pathname.includes("topup")) {
      const index = currentTab.value;
      const tabs = document.querySelector(`.tabs`);
      const tab = document.querySelector(`.tabs__item${index}`);
      const leftTabsPosition = Math.round(tabs.getBoundingClientRect().left);
      const leftTabPosition = Math.round(tab.getBoundingClientRect().left);
      const diff = leftTabPosition - leftTabsPosition;
      const currentTabWidth = tab.getBoundingClientRect().width;

      setIndicatoPosition(diff);
      setCurrentTabWidth(currentTabWidth);
      setModalData("data");
    }
  }, [currentTab.value]);

  const onChangeTabsHandler = (value) => {
    setCurrentTab(value);
    setTabsActive(true);
    setUserInput("");
    setSuggestionCountryPlanPage();
    setSuggestionRegionPlanPage();
  };
  // Tabs

  const handleFilterChange = (filterValues) => {
    // Destructure the filter values
    const {
      minValue,
      maxValue,
      minValidityValue,
      maxValidityValue,
      minPriceValue,
      maxPriceValue,
    } = filterValues;

    // Filter the plans based on the selected ranges
    const filteredData = userPlans.filter((plan) => {
      const size = parseFloat(plan.SIZE);
      const price = parseFloat(plan.PRICE.replace("£", ""));

      return (
        size >= minValue &&
        size <= maxValue &&
        parseFloat(plan.VALIDITY) >= minValidityValue &&
        parseFloat(plan.VALIDITY) <= maxValidityValue &&
        price >= minPriceValue &&
        price <= maxPriceValue
      );
    });

    setFilteredPlans(filteredData);
  };

  const filterPlans = () => {
    const filteredData = userPlans.filter((plan) => {
      // Convert all the plan data fields to lowercase for case-insensitive search
      const searchData = Object.values(plan)
        .map((value) => String(value).toLowerCase())
        .join(" ");
      return searchData.includes(searchText.toLowerCase());
    });

    setFilteredPlans(filteredData);
  };
  useEffect(() => {
    RegionListApi();
    countryList();
    // setIsLoading(false);
  }, []); // Empty dependency array ensures this runs only on component mount

  const RegionListApi = async () => {
    // RegionService.
    await RegionListService.regionList().then((response) => {
      if (props.match.params.regionId && response.data) {
        let filteredRegion = response.data.filter((region) => {
          return region.regionId == props.match.params.regionId;
        });
        if (filteredRegion !== null && filteredRegion.length > 0) {
          setPlanPageRegion(filteredRegion[0].regionDescription);
        }
      }
      setMetaDataRegion(response.data);
      setRegions(response.data);

      // setIsLoading(false)
      // setRegionId(response.data.map((rId)=>rId.regionId));
    });
  };
  const countryList = async () => {
    await RegionListService.countryAccordingToRegionList().then((response) => {
      setMetaDataCountry(response.data);
      if (props.match.params.alpha2) {
        let filteredCountry = response.data.filter((country) => {
          return country.alpha2 === props.match.params.alpha2;
        });
        if (filteredCountry !== null && filteredCountry.length > 0) {
          setPlanPageCountry(filteredCountry[0].countryDescription);
        }
      }
      setCountrybasedOnRegion(response.data);
      setEuropeItems(
        response.data.filter(
          (country) => country.subRegion.region.regionDescription === "Europe"
        )
      );
      setAsiaItems(
        response.data.filter(
          (country) => country.subRegion.region.regionDescription === "Asia"
        )
      );
      setAfricaItems(
        response.data.filter(
          (country) => country.subRegion.region.regionDescription === "Africa"
        )
      );
      setAmericasItems(
        response.data.filter(
          (country) => country.subRegion.region.regionDescription === "Americas"
        )
      );
      setOceaniaItems(
        response.data.filter(
          (country) => country.subRegion.region.regionDescription === "Oceania"
        )
      );
    });
  };
  const openCoverageDropdown = (index, regionId) => {
    setIsCoverageDropdownOpen(true);
    document.body.style.overflowY = "hidden";
    setCountryTicketIndex(index);
    // setEsimForIndex(esimIndex)
  };
  const handleInputChange = (event) => {
    setActiveSuggestionIndex(0);

    const userInputValue = event.target.value.trim();
    setUserInput(userInputValue);

    if (userInputValue === "") {
      setSuggestions([]);
      setShowSuggestions(false);
      return;
    }

    // Convert user input to lowercase
    const userInputValueLowercase = userInputValue.toLowerCase();

    // Filter regions based on user input
    const regionSuggestions = regions.filter((region) =>
      region.regionDescription.toLowerCase().includes(userInputValueLowercase)
    );

    // Filter countries based on user input
    const countrySuggestions = allCountries.filter((country) =>
      country.countryDescription
        .toLowerCase()
        .includes(userInputValueLowercase)
    );

    // Combine region and country suggestions and set the suggestions state
    const combinedSuggestions = [
      ...regionSuggestions.map((region) => ({
        suggestionType: "region",
        description: region.regionDescription,
        regionId: region.regionId,
      })),
      ...countrySuggestions.map((country) => ({
        suggestionType: "country",
        description: country.countryDescription,
        Alpha2: country.alpha2,
      })),
    ];

    setIsValidSuggestion(combinedSuggestions.length > 0);
    setSuggestions(combinedSuggestions);
    setShowSuggestions(true);
  };

  const handleSuggestionSearch = (suggestion) => {
    if (suggestion.suggestionType === "region") {
      // Handle region search using the regionId
      // Call your API here with the regionId
      history.push(`/rplans/${suggestion.regionId}`);
      window.location.reload();
    } else if (suggestion.suggestionType === "country") {
      // Handle country search using the Alpha2
      // Call your API here with the Alpha2
      history.push(`/plans/${suggestion.Alpha2}`);
      window.location.reload();
    }
  };
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    };
  }, []);

  const handleSearch = (suggestionType, regionId, Alpha2, description) => {
    if (suggestionType === "region") {
      // Handle region search using the regionId
      // Call your API here with the regionId
      history.push(`/rplans/${regionId}`);
      window.location.reload();
    } else if (suggestionType === "country") {
      // Handle country search using the Alpha2
      // Call your API here with the Alpha2
      history.push(`/plans/${Alpha2}`);
      window.location.reload();
    }
  };

  const activeSuggestionRef = useRef(null);

  const handleKeyDown = (event) => {
    const activeSuggestionElement = activeSuggestionRef.current;

    if (event.key === "ArrowDown") {
      // Move to the next suggestion when the down arrow key is pressed
      setActiveSuggestionIndex(
        (prevIndex) => (prevIndex + 1) % suggestions.length
      );
    } else if (event.key === "ArrowUp") {
      // Move to the previous suggestion when the up arrow key is pressed
      setActiveSuggestionIndex((prevIndex) =>
        prevIndex === 0 ? suggestions.length - 1 : prevIndex - 1
      );
    } else if (event.key === "Enter") {
      // Handle the Enter key press separately
      if (suggestions.length > 0 && suggestions[activeSuggestionIndex]) {
        // Set the selected suggestion before calling handleSearch
        setUserInput(suggestions[activeSuggestionIndex].description);
        setShowSuggestions(false); // Hide the suggestion list when Enter is pressed

        handleSearch(
          suggestions[activeSuggestionIndex].suggestionType,
          suggestions[activeSuggestionIndex].regionId,
          suggestions[activeSuggestionIndex].Alpha2,
          suggestions[activeSuggestionIndex].description
        );
      }
    }

    // Scroll the active suggestion into view when using the arrow keys
    if (activeSuggestionElement) {
      activeSuggestionElement.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start",
      });
    }
  };
  const allCountries = [
    ...europeItems,
    ...asiaItems,
    ...africaItems,
    ...americasItems,
    ...oceaniaItems,
  ];

  useEffect(() => {
    // Initialize the detailsState with an array of false values based on the userPlans length
    setDetailsState(new Array(userPlans.length).fill(false));
  }, [userPlans]);
  // const [alpha2, setAlpha2] = useState(props.match.params.alpha2);
  const regionPlansAPI = async () => {
    await PlansBasedOnRegionService.regionPlan(props.match.params.regionId)
      .then((response) => {
        if (response.status === 200) {
          setPlan(response.data);
          setCountryOrRegion(planPageRegion);
          setRegionId(props.match.params.regionId);
          const formattedData = response.data.map((item) => {
            const dataSize = extractNumericValue(item.data); // Extract numeric value from the data field
            if (dataSize === null) {
              // Handle the case where the data field does not contain a valid numeric value
              return {
                PROVIDER: item.providerName,
                PLANNAME: item.planName,
                SIZE: item.unlimitedPlan == true ? "Unlimited" : item.data,
                VALIDITY: `${item.validity} Days`,
                "PRICE/GB": "N/A", // Set a placeholder value for non-numeric data
                PRICE: `£${item.price}`,
                planId: item,
              };
            }
            const pricePerGB = item.price / dataSize;
            const truncatedPricePerGB = Math.trunc(pricePerGB * 10) / 10; // Truncate to one digit after the decimal point
            return {
              PROVIDER: item.providerName,
              PLANNAME: item.planName,
              SIZE: item.unlimitedPlan == true ? "Unlimited" : item.data,
              VALIDITY: `${item.validity} Days`,
              "PRICE/GB":
                item.unlimitedPlan == true
                  ? "NA/-"
                  : truncatedPricePerGB.toFixed(1),
              PRICE: `£${item.price}`,
              planId: item,
            };
          });
          setPlansFound(true);
          setUserPlans(formattedData);
          const regionPopularPlans = response.data.slice(0, 2);
          // setPopular(regionPopularPlans);
          const regionUnlimitedPlans = response.data
            .filter((plan) => plan.unlimitedPlan === true)
            .slice(0, 2);
          setUnlimited(regionUnlimitedPlans);
        }
      })
      .catch((error) => {
        if (error.message === "Network Error") {
          setMessage(error.message);
        } else {
          switch (error.response ? error.response.status : "") {
            case 401:
              break;
            case 403:
              // this.props.history.push(`/accessDenied`)
              break;
            case 500:
            case 404:
            case 406:
              setPlansFound(false);
              setMessage("No Plans Available");
              break;
            case 412:
              break;
            default:
              setMessage("Unknown Error");

              break;
          }
        }
      });
  };

  const globalPlansAPI = async () => {
    await GlobalPlansService.globalPopularPlanByCategory(
      props.match.params.globalId
    )
      .then((response) => {
        if (response.status === 200) {
          setPlan(response.data);
          setCountryOrRegion(planPageCountry);
          // setAlpha2(props.match.params.alpha2);
          const formattedData = response.data.map((item) => {
            const dataSize = extractNumericValue(item.data); // Extract numeric value from the data field
            if (dataSize === null) {
              // Handle the case where the data field does not contain a valid numeric value
              return {
                PROVIDER: item.providerName,
                PLANNAME: item.planName,
                SIZE: item.unlimitedPlan == true ? "Unlimited" : item.data,
                VALIDITY: `${item.validity} Days`,
                "PRICE/GB": "N/A", // Set a placeholder value for non-numeric data
                PRICE: `£${item.price}`,
                planId: item,
              };
            }
            const pricePerGB = item.price / dataSize;
            const truncatedPricePerGB = Math.trunc(pricePerGB * 10) / 10; // Truncate to one digit after the decimal point
            return {
              PROVIDER: item.providerName,
              PLANNAME: item.planName,
              SIZE: item.unlimitedPlan == true ? "Unlimited" : item.data,
              VALIDITY: `${item.validity} Days`,
              "PRICE/GB":
                item.unlimitedPlan == true
                  ? "NA/-"
                  : truncatedPricePerGB.toFixed(1),
              PRICE: `£${item.price}`,
              planId: item,
            };
          });
          setPlansFound(true);
          setUserPlans(formattedData);
          // setCountry(
          //   response.data.map((item) => item.country.countryDescription)
          // );
          // const popularPlans = response.data.slice(0, 2);
          // setPopular(popularPlans);
          const unlimitedPlans = response.data
            .filter((plan) => plan.unlimitedPlan === true)
            .slice(0, 2);
          setUnlimited(unlimitedPlans);
        }
      })
      .catch((error) => {
        if (error.message === "Network Error") {
          setMessage(error.message);
        } else {
          switch (error.response ? error.response.status : "") {
            case 401:
              break;
            case 403:
              // this.props.history.push(`/accessDenied`)
              break;
            case 500:
            case 404:
            case 406:
              setPlansFound(false);
              setMessage("No Plans Available");
              break;
            case 412:
              break;
            default:
              setMessage("Unknown Error");

              break;
          }
        }
      });
  };
  const plansAPI = async () => {
    //
    await PlansBasedOnCountryService.counrtyPlan(props.match.params.alpha2)
      .then((response) => {
        if (response.status === 200) {
          setPlan(response.data);
          setCountryOrRegion(planPageCountry);
          setAlpha2(props.match.params.alpha2);
          const formattedData = response.data.map((item) => {
            const dataSize = extractNumericValue(item.data); // Extract numeric value from the data field
            if (dataSize === null) {
              // Handle the case where the data field does not contain a valid numeric value
              return {
                PROVIDER: item.providerName,
                PLANNAME: item.planName,
                SIZE: item.unlimitedPlan == true ? "Unlimited" : item.data,
                VALIDITY: `${item.validity} Days`,
                "PRICE/GB": "N/A", // Set a placeholder value for non-numeric data
                PRICE: `£${item.price}`,
                planId: item,
              };
            }
            const pricePerGB = item.price / dataSize;
            const truncatedPricePerGB = Math.trunc(pricePerGB * 10) / 10; // Truncate to one digit after the decimal point
            return {
              PROVIDER: item.providerName,
              PLANNAME: item.planName,
              SIZE: item.unlimitedPlan == true ? "Unlimited" : item.data,
              VALIDITY: `${item.validity} Days`,
              "PRICE/GB":
                item.unlimitedPlan == true
                  ? "NA/-"
                  : truncatedPricePerGB.toFixed(1),
              PRICE: `£${item.price}`,
              planId: item,
            };
          });
          setPlansFound(true);
          setUserPlans(formattedData);
          setCountry(
            response.data.map((item) => item.country.countryDescription)
          );
          const popularPlans = response.data.slice(0, 2);
          // setPopular(popularPlans);
          const unlimitedPlans = response.data
            .filter((plan) => plan.unlimitedPlan === true)
            .slice(0, 2);
          setUnlimited(unlimitedPlans);
          //
        }
      })
      .catch((error) => {
        if (error.message === "Network Error") {
          // this.setState({
          //   message: error.message,
          //   loading: false
          // });
          setMessage(error.message);
        } else {
          switch (error.response ? error.response.status : "") {
            case 401:
              // this.setState({
              //   loading: false
              // }, );
              break;
            case 403:
              // this.props.history.push(`/accessDenied`)
              break;
            case 500:
            case 404:
            case 406:
              // this.setState({
              //   message: "No Plans Available",
              //   loading: false
              // });
              setPlansFound(false);
              setMessage("No Plans Available");
              break;
            case 412:
              // this.setState({
              //   // message: error.response.data.messageCode,
              //   loading: false
              // });
              break;
            default:
              setMessage("Unknown Error");

              break;
          }
        }
      });
  };
  const tileRegionPlansAPI = async () => {
    await PlansBasedOnRegionService.tileRegionPlan(props.match.params.regionId)
      .then((response) => {
        if (response.status === 200) {
          // setPlan(response.data);
          setPlansFound(true);
          const popularPlans = response.data.slice(0, 2);
          setPopular(popularPlans);
          const premium = response.data.slice(2, 4);
          setPremium(premium);
          const unlimitedOrOther = response.data.slice(4, 6);
          setUnlimitedOrOther(unlimitedOrOther);
          const randomPlans = response.data.slice(6);
          setRandomPlans2(randomPlans);
        }
      })
      .catch((error) => {
        if (error.message === "Network Error") {
          setMessage(error.message);
        } else {
          switch (error.response ? error.response.status : "") {
            case 401:
              break;
            case 403:
              // this.props.history.push(`/accessDenied`)
              break;
            case 500:
            case 404:
            case 406:
              setPlansFound(false);
              setMessage("No Plans Available");
              break;
            case 412:
              break;
            default:
              setMessage("Unknown Error");

              break;
          }
        }
      });
  };

  const tileGlobalPlansAPI = async () => {
    await GlobalPlansService.globalAllPlan()
      .then((response) => {
        if (response.status === 200) {
          // setPlan(response.data);
          setPlansFound(true);
          const popularPlans = response.data.slice(0, 2);
          setPopular(popularPlans);
          const premium = response.data.slice(2, 4);
          setPremium(premium);
          const unlimitedOrOther = response.data.slice(4, 6);
          setUnlimitedOrOther(unlimitedOrOther);
          const randomPlans = response.data.slice(6);
          setRandomPlans2(randomPlans);
        }
      })
      .catch((error) => {
        if (error.message === "Network Error") {
          setMessage(error.message);
        } else {
          switch (error.response ? error.response.status : "") {
            case 401:
              break;
            case 403:
              break;
            case 500:
            case 404:
            case 406:
              setPlansFound(false);
              setMessage("No Plans Available");
              break;
            case 412:
              break;
            default:
              setMessage("Unknown Error");
              break;
          }
        }
      });
  };

  const tilePlansAPI = async () => {
    await PlansBasedOnCountryService.tileCountryPlan(props.match.params.alpha2)
      .then((response) => {
        if (response.status === 200) {
          // setPlan(response.data);
          setPlansFound(true);
          const popularPlans = response.data.slice(0, 2);
          setPopular(popularPlans);
          const premium = response.data.slice(2, 4);
          setPremium(premium);
          const unlimitedOrOther = response.data.slice(4, 6);
          setUnlimitedOrOther(unlimitedOrOther);
          const randomPlans = response.data.slice(6);
          setRandomPlans2(randomPlans);
        }
      })
      .catch((error) => {
        if (error.message === "Network Error") {
          setMessage(error.message);
        } else {
          switch (error.response ? error.response.status : "") {
            case 401:
              break;
            case 403:
              break;
            case 500:
            case 404:
            case 406:
              setPlansFound(false);
              setMessage("No Plans Available");
              break;
            case 412:
              break;
            default:
              setMessage("Unknown Error");
              break;
          }
        }
      });
  };
  useEffect(() => {
    // Check if 'alpha2' is available in the route params
    if (!props.match.params.alpha2 && !props.match.params.regionId) {
      globalPlansAPI();
      tileGlobalPlansAPI();
    }

    // Add other conditions if needed
  }, []);

  useEffect(() => {
    // setIsLoading(true);
    // Check if 'alpha2' is available in the route params
    if (props.match.params.alpha2) {
      plansAPI();
      tilePlansAPI();
    }
    // Check if 'regionId' is available in the route params
    else if (props.match.params.regionId) {
      regionPlansAPI();
      tileRegionPlansAPI();
    } else if (props.match.params.globalId) {
      globalPlansAPI();
      tileGlobalPlansAPI();
    }
    // setIsLoading(false);
    // Add other conditions if needed
  }, [
    props.match.params.alpha2,
    props.match.params.regionId,
    countryBasedOnRegion,
    regions,
  ]);
  const globalCoverageDropdownRef = useRef(null);
  const [isCoverageDropdownOpenForGlobal, setIsCoverageDropdownOpenForGlobal] =
    useState();

  const openCoverageDropdownForGlobal = (index, globalId) => {
    setIsCoverageDropdownOpenForGlobal(true);
    setGlobalCountryTicketIndex(index);
    document.body.style.overflowY = "hidden";
  };
  var globalIndex = globalCountry[globalCountryTicketIndex];
  const closeCoverageDropdownForGlobal = () => {
    setIsCoverageDropdownOpenForGlobal(false);
    document.body.style.overflowY = "auto";
  };
  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth <= 1100) {
        setIcon(true);
        setBuy(true);
      } else {
        setIcon(false);
        setBuy(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const sortPlansByPrice = (plans) => {
    if (!plans || plans.length === 0) {
      return [];
    }
    const sortedPlans = plans
      .slice()
      .sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
    return sortedPlans.map((item, index) => {
      const dataSize = extractNumericValue(item.data); // Extract numeric value from the data field
      if (dataSize === null) {
        // Handle the case where the data field does not contain a valid numeric value
        return {
          PROVIDER: item.providerName,
          PLANNAME: item.planName,
          SIZE: item.unlimitedPlan == true ? "Unlimited" : item.data,
          VALIDITY: `${item.validity} Days`,
          "PRICE/GB": "N/A", // Set a placeholder value for non-numeric data
          PRICE: `£${item.price}`,
          planId: item,
        };
      }
      const pricePerGB = item.price / dataSize;
      // const truncatedPricePerGB = Math.trunc(pricePerGB * 10) / 10; // Truncate to one digit after the decimal point
      let truncatedPricePerGB;

      const numericValue = parseFloat(pricePerGB);

      if (isNaN(numericValue) || !isFinite(numericValue)) {
        truncatedPricePerGB = "N/A"; // or "Infinity", or whatever string you prefer
      } else {
        truncatedPricePerGB = Math.trunc(numericValue * 10) / 10;
      }
      return {
        PROVIDER: item.providerName,
        PLANNAME: item.planName,
        SIZE: item.unlimitedPlan == true ? "Unlimited" : item.data,
        VALIDITY: `${item.validity} Days`,
        "PRICE/GB":
          item.unlimitedPlan == true ? "NA/-" : truncatedPricePerGB,
        PRICE: `£${item.price}`,
        planId: item,
      };
    });
  };

  const handleCheapestFilterClick = () => {
    if (unlimitedFilter == true) {
      setPlan(forUnlimitedPlans);
      const sortedUnlimitedPlans = sortPlansByPrice(forUnlimitedPlans);
      setUserPlans(sortPlansByPrice(forUnlimitedPlans));
    } else {
      if (props.match.params.regionId) {
        PlansBasedOnRegionService.regionPlan(props.match.params.regionId).then(
          (response) => {
            if (response.status === 200) {
              setPlan(response.data);
              const sortedPlans = sortPlansByPrice(response.data);
              setUserPlans(sortedPlans); // Update state with the new sorted array
            }
          }
        );
      }
      if (props.match.params.alpha2) {
        PlansBasedOnCountryService.counrtyPlan(props.match.params.alpha2).then(
          (response) => {
            setPlan(response.data);
            if (response.status === 200) {
              const sortedPlans = sortPlansByPrice(response.data);
              setUserPlans(sortedPlans); // Update state with the new sorted array
            }
          }
        );
      }
      if (!props.match.params.alpha2 && !props.match.params.regionId) {
        GlobalPlansService.globalPlan().then((response) => {
          setPlan(response.data);
          if (response.status === 200) {
            const sortedPlans = sortPlansByPrice(response.data);
            setUserPlans(sortedPlans); // Update state with the new sorted array
          }
        });
      }
    }
  };

  const [unlimitedFilter, setUnlimitedFilter] = useState(false);

  const handleUnlimitedToggle = () => {
    setUnlimitedFilter(!unlimitedFilter);
  };

  const forUnlimited = (plans) => {
    if (!plans || plans.length === 0) {
      return [];
    }

    return plans.map((item) => {
      const dataSize = extractNumericValue(item.data); // Extract numeric value from the data field
      if (dataSize === null) {
        // Handle the case where the data field does not contain a valid numeric value
        return {
          PROVIDER: item.providerName,
          PLANNAME: item.planName,
          SIZE: item.unlimitedPlan == true ? "Unlimited" : item.data,
          VALIDITY: `${item.validity} Days`,
          "PRICE/GB": "N/A", // Set a placeholder value for non-numeric data
          PRICE: `£${item.price}`,
          planId: item,
        };
      }
      const pricePerGB = item.price / dataSize;
      const truncatedPricePerGB = Math.trunc(pricePerGB * 10) / 10; // Truncate to one digit after the decimal point
      return {
        PROVIDER: item.providerName,
        PLANNAME: item.planName,
        SIZE: item.unlimitedPlan == true ? "Unlimited" : item.data,
        VALIDITY: `${item.validity} Days`,
        "PRICE/GB":
          item.unlimitedPlan == true ? "NA/-" : truncatedPricePerGB.toFixed(1),
        PRICE: `£${item.price}`,
        planId: item,
      };
    });
  };

  const [forUnlimitedPlans, setForUnlimitedPlans] = useState([]);
  const unlimitedToggle = () => {
    if (props.match.params.regionId) {
      PlansBasedOnRegionService.regionPlan(props.match.params.regionId).then(
        (response) => {
          if (response.status === 200) {
            const filteredData = response.data.filter(
              (plan) => plan.unlimitedPlan === true
            );
            setPlan(filteredData);
            const unlimitedPlans = forUnlimited(filteredData);
            setForUnlimitedPlans(filteredData);
            setUserPlans(unlimitedPlans); // Update state with the new sorted array
          }
        }
      );
    }
    if (props.match.params.alpha2) {
      PlansBasedOnCountryService.counrtyPlan(props.match.params.alpha2).then(
        (response) => {
          // setPlan(response.data);
          if (response.status === 200) {
            const filteredData = response.data.filter(
              (plan) => plan.unlimitedPlan === true
            );
            setPlan(filteredData);
            const unlimitedPlans = sortPlansByPrice(filteredData);
            setForUnlimitedPlans(filteredData);
            setUserPlans(unlimitedPlans); // Update state with the new sorted array
          }
        }
      );
    }

    if (!props.match.params.alpha2 && !props.match.params.regionId) {
      GlobalPlansService.globalPlan().then((response) => {
        // setPlan(response.data);
        if (response.status === 200) {
          const filteredData = response.data.filter(
            (plan) => plan.unlimitedPlan === true
          );
          setPlan(filteredData);
          const unlimitedPlans = sortPlansByPrice(filteredData);
          setForUnlimitedPlans(filteredData);
          setUserPlans(unlimitedPlans); // Update state with the new sorted array
        }
      });
    }
  };

  function extractNumericValue(dataString) {
    const numericValue = parseFloat(dataString); // Attempt to convert the whole string to a number
    return isNaN(numericValue) ? null : numericValue; // Return null if the conversion fails
  }

  const handleBestPricePerGBFilterClick = () => {
    if (unlimitedFilter == true) {
      // Sorting the data based on "PRICE/GB" column in ascending order
      const sortBestPricePerGBUnlimitedData = forUnlimitedPlans.map((item) => {
        const dataSize = extractNumericValue(item.data); // Extract numeric value from the data field
        if (dataSize === null) {
          // Handle the case where the data field does not contain a valid numeric value
          return {
            PROVIDER: item.providerName,
            PLANNAME: item.planName,
            SIZE: item.unlimitedPlan == true ? "Unlimited" : item.data,
            VALIDITY: `${item.validity} Days`,
            "PRICE/GB": "N/A", // Set a placeholder value for non-numeric data
            PRICE: `£${item.price}`,
            planId: item,
          };
        }
        const pricePerGB = item.price / dataSize;
        const truncatedPricePerGB = Math.trunc(pricePerGB * 10) / 10; // Truncate to one digit after the decimal point
        return {
          PROVIDER: item.providerName,
          PLANNAME: item.planName,
          SIZE: item.unlimitedPlan == true ? "Unlimited" : item.data,
          VALIDITY: `${item.validity} Days`,
          "PRICE/GB":
            item.unlimitedPlan == true
              ? "NA/-"
              : truncatedPricePerGB.toFixed(1),
          PRICE: `£${item.price}`,
          planId: item,
        };
      });
      const sortedUnlimitedPlans = sortBestPricePerGBUnlimitedData
        .slice()
        .sort((a, b) => parseFloat(a["PRICE/GB"]) - parseFloat(b["PRICE/GB"]));

      setUserPlans(sortedUnlimitedPlans);
    } else {
      if (props.match.params.regionId) {
        PlansBasedOnRegionService.regionPlan(props.match.params.regionId).then(
          (response) => {
            if (response.status === 200) {
              setPlan(response.data);
              const sortBestPricePerGBData = response.data.map((item) => {
                const dataSize = extractNumericValue(item.data); // Extract numeric value from the data field
                if (dataSize === null) {
                  // Handle the case where the data field does not contain a valid numeric value
                  return {
                    PROVIDER: item.providerName,
                    PLANNAME: item.planName,
                    SIZE: item.unlimitedPlan == true ? "Unlimited" : item.data,
                    VALIDITY: `${item.validity} Days`,
                    "PRICE/GB": "N/A", // Set a placeholder value for non-numeric data
                    PRICE: `£${item.price}`,
                    planId: item,
                  };
                }
                const pricePerGB = item.price / dataSize;
                const truncatedPricePerGB = Math.trunc(pricePerGB * 10) / 10; // Truncate to one digit after the decimal point
                return {
                  PROVIDER: item.providerName,
                  PLANNAME: item.planName,
                  SIZE: item.unlimitedPlan == true ? "Unlimited" : item.data,
                  VALIDITY: `${item.validity} Days`,
                  "PRICE/GB":
                    item.unlimitedPlan == true
                      ? "NA/-"
                      : truncatedPricePerGB.toFixed(1),
                  PRICE: `£${item.price}`,
                  planId: item,
                };
              });

              // Sorting the data based on "PRICE/GB" column in ascending order
              sortBestPricePerGBData.sort(
                (a, b) => parseFloat(a["PRICE/GB"]) - parseFloat(b["PRICE/GB"])
              );

              setUserPlans(sortBestPricePerGBData);
            }
          }
        );
      }

      if (props.match.params.alpha2) {
        PlansBasedOnCountryService.counrtyPlan(props.match.params.alpha2).then(
          (response) => {
            if (response.status === 200) {
              console.log("plans comming",response.data)
              const filteredDataPlans = response.data.filter(
                (plan) => plan.planCategory?.planCategoryId === 1
              );
              const unlimitedPlans  = filteredDataPlans.filter(
                (plan) => plan.unlimitedPlan === true
              );
              const dataPlans  = filteredDataPlans.filter(
                (plan) => plan.unlimitedPlan === false
              );

              console.log("filteredPlans comming",filteredDataPlans)
              setPlan(response.data);
              const sortBestPricePerGBData = dataPlans.map((item) => {
                const dataSize = extractNumericValue(item.data); // Extract numeric value from the data field
                if (dataSize === null) {
                  // Handle the case where the data field does not contain a valid numeric value
                  return {
                    PROVIDER: item.providerName,
                    PLANNAME: item.planName,
                    SIZE: item.unlimitedPlan == true ? "Unlimited" : item.data,
                    VALIDITY: `${item.validity} Days`,
                    "PRICE/GB": "N/A", // Set a placeholder value for non-numeric data
                    PRICE: `£${item.price}`,
                    planId: item,
                  };
                }
                const pricePerGB = item.price / dataSize;
                const truncatedPricePerGB = Math.trunc(pricePerGB * 10) / 10; // Truncate to one digit after the decimal point
                return {
                  PROVIDER: item.providerName,
                  PLANNAME: item.planName,
                  SIZE: item.unlimitedPlan == true ? "Unlimited" : item.data,
                  VALIDITY: `${item.validity} Days`,
                  "PRICE/GB":
                    item.unlimitedPlan == true
                      ? "NA/-"
                      : truncatedPricePerGB.toFixed(1),
                  PRICE: `£${item.price}`,
                  planId: item,
                };
              });
              
              const unlimitedPlansMapped = unlimitedPlans.map((item) => {
                const dataSize = extractNumericValue(item.data); // Extract numeric value from the data field
                if (dataSize === null) {
                  // Handle the case where the data field does not contain a valid numeric value
                  return {
                    PROVIDER: item.providerName,
                    PLANNAME: item.planName,
                    SIZE: item.unlimitedPlan == true ? "Unlimited" : item.data,
                    VALIDITY: `${item.validity} Days`,
                    "PRICE/GB": "N/A", // Set a placeholder value for non-numeric data
                    PRICE: `£${item.price}`,
                    planId: item,
                  };
                }
                const pricePerGB = item.price / dataSize;
                const truncatedPricePerGB = Math.trunc(pricePerGB * 10) / 10; // Truncate to one digit after the decimal point
                return {
                  PROVIDER: item.providerName,
                  PLANNAME: item.planName,
                  SIZE: item.unlimitedPlan == true ? "Unlimited" : item.data,
                  VALIDITY: `${item.validity} Days`,
                  "PRICE/GB":
                    item.unlimitedPlan == true
                      ? "NA/-"
                      : truncatedPricePerGB.toFixed(1),
                  PRICE: `£${item.price}`,
                  planId: item,
                };
              });

              const otherPlans = response.data.filter(
                (plan) => plan.planCategory?.planCategoryId !== 1
              ).map((item) => {
                const dataSize = extractNumericValue(item.data); // Extract numeric value from the data field
                if (dataSize === null) {
                  // Handle the case where the data field does not contain a valid numeric value
                  return {
                    PROVIDER: item.providerName,
                    PLANNAME: item.planName,
                    SIZE: item.unlimitedPlan == true ? "Unlimited" : item.data,
                    VALIDITY: `${item.validity} Days`,
                    "PRICE/GB": "N/A", // Set a placeholder value for non-numeric data
                    PRICE: `£${item.price}`,
                    planId: item,
                  };
                }
                const pricePerGB = item.price / dataSize;
                const truncatedPricePerGB = Math.trunc(pricePerGB * 10) / 10; // Truncate to one digit after the decimal point
                return {
                  PROVIDER: item.providerName,
                  PLANNAME: item.planName,
                  SIZE: item.unlimitedPlan == true ? "Unlimited" : item.data,
                  VALIDITY: `${item.validity} Days`,
                  "PRICE/GB":
                    item.unlimitedPlan == true
                      ? "NA/-" 
                      : item.planCategory?.planCategoryId !== 1 ? "-" : truncatedPricePerGB.toFixed(1),
                  PRICE: `£${item.price}`,
                  planId: item,
                };
              });
              // Sorting the data based on "PRICE/GB" column in ascending order
              sortBestPricePerGBData.sort(
                (a, b) => parseFloat(a["PRICE/GB"]) - parseFloat(b["PRICE/GB"])
              );
              const combinedPlans = [...unlimitedPlansMapped, ...sortBestPricePerGBData, ...otherPlans];
              setUserPlans(combinedPlans);
            }
          }
        );
      }
    }
  };

  const sortPlansByLargestGB = (plans) => {
    const unitMultiplier = {
      MB: 1,
      GB: 1024,
      TB: 1024 * 1024
    };

    const sortedPlans = plans.slice().sort((a, b) => {
      const isUnlimitedA = a.data.toLowerCase() === "unlimited";
      const isUnlimitedB = b.data.toLowerCase() === "unlimited";

      if (isUnlimitedA && !isUnlimitedB) return -1; // A is unlimited, goes first
      if (!isUnlimitedA && isUnlimitedB) return 1;  // B is unlimited, goes first
      if (isUnlimitedA && isUnlimitedB) return 0;   // Both are unlimited

      const [valueA, unitA] = a.data.split(" ");
      const [valueB, unitB] = b.data.split(" ");
      const sizeA = parseFloat(valueA) * unitMultiplier[unitA];
      const sizeB = parseFloat(valueB) * unitMultiplier[unitB];
      return sizeB - sizeA;
    });
    return sortedPlans.map((item, index) => {
      const dataSize = extractNumericValue(item.data); // Extract numeric value from the data field
      if (dataSize === null) {
        // Handle the case where the data field does not contain a valid numeric value
        return {
          PROVIDER: item.providerName,
          PLANNAME: item.planName,
          SIZE: item.unlimitedPlan == true ? "Unlimited" : item.data,
          VALIDITY: `${item.validity} Days`,
          "PRICE/GB": "N/A", // Set a placeholder value for non-numeric data
          PRICE: `£${item.price}`,
          planId: item,
        };
      }
      const pricePerGB = item.price / dataSize;
      const truncatedPricePerGB = Math.trunc(pricePerGB * 10) / 10; // Truncate to one digit after the decimal point
      return {
        PROVIDER: item.providerName,
        PLANNAME: item.planName,
        SIZE: item.unlimitedPlan == true ? "Unlimited" : item.data,
        VALIDITY: `${item.validity} Days`,
        "PRICE/GB":
          item.unlimitedPlan == true || item.planCategory.planCategoryId != DATA_ONLY ? "NA/-" : truncatedPricePerGB.toFixed(1),
        PRICE: `£${item.price}`,
        planId: item,
      };
    });
  };

  const handleLargestGBFilterClick = () => {
    if (unlimitedFilter == true) {
      setPlan(forUnlimitedPlans);
      const sortedUnlimitedPlans = sortPlansByLargestGB(forUnlimitedPlans);
      setUserPlans(sortedUnlimitedPlans);
    } else {
      if (props.match.params.regionId) {
        PlansBasedOnRegionService.regionPlan(props.match.params.regionId).then(
          (response) => {
            setPlan(response.data);
            if (response.status === 200) {
              const sortedPlansLGB = sortPlansByLargestGB(response.data);
              setUserPlans(sortedPlansLGB); // Update state with the new sorted array
            }
          }
        );
      }
      if (props.match.params.alpha2) {
        PlansBasedOnCountryService.counrtyPlan(props.match.params.alpha2).then(
          (response) => {
            setPlan(response.data);
            if (response.status === 200) {
              const sortedPlansLGB = sortPlansByLargestGB(response.data);
              setUserPlans(sortedPlansLGB); // Update state with the new sorted array
            }
          }
        );
      }
      if (!props.match.params.alpha2 && !props.match.params.regionId) {
        GlobalPlansService.globalPlan().then((response) => {
          setPlan(response.data);
          if (response.status === 200) {
            const sortedPlansLGB = sortPlansByLargestGB(response.data);
            setUserPlans(sortedPlansLGB); // Update state with the new sorted array
          }
        });
      }
    }
  };

  const sortPlansByLongestValidity = (plans) => {
    const sortedPlans = plans
      .slice()
      .sort((a, b) => parseInt(b.validity) - parseInt(a.validity));
    return sortedPlans.map((item, index) => {
      const dataSize = extractNumericValue(item.data); // Extract numeric value from the data field
      if (dataSize === null) {
        // Handle the case where the data field does not contain a valid numeric value
        return {
          PROVIDER: item.providerName,
          PLANNAME: item.planName,
          SIZE: item.unlimitedPlan == true ? "Unlimited" : item.data,
          VALIDITY: `${item.validity} Days`,
          "PRICE/GB": "N/A", // Set a placeholder value for non-numeric data
          PRICE: `£${item.price}`,
          planId: item,
        };
      }
      const pricePerGB = item.price / dataSize;
      const truncatedPricePerGB = Math.trunc(pricePerGB * 10) / 10; // Truncate to one digit after the decimal point
      return {
        PROVIDER: item.providerName,
        PLANNAME: item.planName,
        SIZE: item.unlimitedPlan == true ? "Unlimited" : item.data,
        VALIDITY: `${item.validity} Days`,
        "PRICE/GB":
          item.unlimitedPlan == true ? "NA/-" : truncatedPricePerGB.toFixed(1),
        PRICE: `£${item.price}`,
        planId: item,
      };
    });
  };

  const handleLongestValidityFilterClick = () => {
    if (unlimitedFilter == true) {
      setPlan(forUnlimitedPlans);
      const sortedUnlimitedPlans =
        sortPlansByLongestValidity(forUnlimitedPlans);
      setUserPlans(sortedUnlimitedPlans);
    } else {
      if (props.match.params.regionId) {
        PlansBasedOnRegionService.regionPlan(props.match.params.regionId).then(
          (response) => {
            setPlan(response.data);
            if (response.status === 200) {
              const sortedPlansLG = sortPlansByLongestValidity(response.data);
              setUserPlans(sortedPlansLG); // Update state with the new sorted array
            }
          }
        );
      }
      if (props.match.params.alpha2) {
        PlansBasedOnCountryService.counrtyPlan(props.match.params.alpha2).then(
          (response) => {
            setPlan(response.data);
            if (response.status === 200) {
              const sortedPlansLG = sortPlansByLongestValidity(response.data);
              setUserPlans(sortedPlansLG); // Update state with the new sorted array
            }
          }
        );
      }
      if (!props.match.params.alpha2 && !props.match.params.regionId) {
        GlobalPlansService.globalPlan().then((response) => {
          setPlan(response.data);
          if (response.status === 200) {
            const sortedPlansLG = sortPlansByLongestValidity(response.data);
            setUserPlans(sortedPlansLG); // Update state with the new sorted array
          }
        });
      }
    }
  };

  useEffect(() => {
    setIsLoading(true);
    if (planPageCountry || planPageRegion) {
      fetch(
        `https://api.unsplash.com/search/photos?page=1&query=${planPageCountry ? planPageCountry : planPageRegion
        }&client_id=2xy-v7zAMswuSraDWvCI6KJ8qzgOh60UExiwJfCwuQ4`
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          setImageLoaded(true);
          if (planPageRegion && planPageRegion == "T20 WC Region 1") {
            setCountryBg(t20Wc1);
            setIsLoading(false);
          } else if (planPageRegion && planPageRegion == "T20 WC Region 2") {
            setCountryBg(t20Wc2);
            setIsLoading(false);
          } else if (planPageCountry) {
            setCountryBg(data.results[1].urls.regular);
            setIsLoading(false);
          } else if (planPageRegion) {
            setCountryBg(data.results[1].urls.regular);
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setImageLoaded(true);
          setIsLoading(false);
        });
    }
    // setIsLoading(false);
  }, [planPageCountry, planPageRegion, location]);

  const [details, setDetails] = useState([]);
  const columns = [
    {
      key: `${plansFound ? "avatar" : ""}`,
      label: "",
      filter: false,
      sorter: false,
      _style: { width: "5%" },
    },
    {
      key: "PROVIDER",
      _style: { width: "15%" },
    },
    {
      key: "PLANNAME",
      _style: { width: "15%" },
    },
    {
      key: "SIZE",
      _style: { width: "10%" },
    },
    {
      key: "VALIDITY",
      _style: { width: "10%" },
    },
    {
      key: "PRICE/GB",
      _style: { width: "10%" },
    },

    {
      key: "PRICE",
      _style: { width: "5%" },
    },

    // {
    //   key: `${plansFound ? "show_details" : ""}`,
    //   label: "",
    //   _style: { width: "10%" },
    //   filter: false,
    //   sorter: false,
    // },
    // {
    //   key: `${plansFound ? "show_Buy" : ""}`,
    //   label: "",
    //   _style: { width: "15%" },
    //   filter: false,
    //   sorter: false,
    // },
  ];
  const usersData = [
    {
      id: 1,

      PROVIDER: "Samppa Nori",
      avatar: logo,
      PLANNAME: "eSIM Pheonix",
      SIZE: "100MB",
      VALIDITY: "100 Days",
      PRICEGB: "$30",
      PRICE: "$3",
      view: "",
    },
  ];
  // const getBadge = (VALIDITY) => {
  //   switch (VALIDITY) {
  //     case "Active":
  //       return "success";
  //     case "Inactive":
  //       return "secondary";
  //     case "Pending":
  //       return "warning";
  //     case "Banned":
  //       return "danger";
  //     default:
  //       return "primary";
  //   }
  // };
  // const toggleDetails = (index) => {
  //   const position = details.indexOf(index);
  //   let newDetails = details.slice();
  //   if (position !== -1) {
  //     newDetails.splice(position, 1);
  //   } else {
  //     newDetails = [...details, index];
  //   }
  //   setDetails(newDetails);
  // };
  const toggleDetails = (index) => {
    setDetailsState((prevState) => {
      const newState = [...prevState];
      newState[index] = !newState[index];
      return newState;
    });
  };
  // const toggleBuy = (planId, rowIndex) => {
  //   // Check user verification status in local storage
  //   const email = localStorage.getItem("emailId");
  //   if (!email || email === "" || email === undefined || email === null) {
  //     setShowLoginPopUp(true);
  //   } else if (email || email !== "" || email !== undefined) {
  //     // var userVerificationStatus = localStorage.getItem("userVerificationStatus");
  //     // if(localStorage.getItem("userVerificationStatus") == 0){
  //     if (localStorage.getItem("token")) {
  //       const token = localStorage.getItem("token");
  //       const user = jwtDecode(token);
  //       const exp = user.exp;
  //       const currentTime = Math.floor(Date.now() / 1000);
  //       if (exp < currentTime) {
  //         localStorage.clear();
  //         history.push("/");
  //       }
  //       UserVarificationService.getVerificationStatus(
  //         localStorage.getItem("userId")
  //       ).then((response) => {
  //         if (response.status == 200) {
  //           // localStorage.setItem("userVerificationStatus", response.data);
  //           const userVerificationStatus = response.data;
  //           if (!userVerificationStatus || userVerificationStatus === "0") {
  //             // Show popup for unverified user
  //             setShowVerifyPopup(true);
  //           } else if (
  //             userVerificationStatus ||
  //             userVerificationStatus === "1"
  //           ) {
  //             // User is verified
  //             DashboardDetailsService.dashboardDetailService(
  //               localStorage.getItem("userId")
  //             ).then((response) => {
  //               if (response.status === 200) {
  //                 localStorage.setItem(
  //                   "referralCode",
  //                   response.data.referralCode
  //                 );
  //                 const plan = planId;
  //                 PlansBasedOnCountryService.getPlanByPlanId(plan.planId).then(
  //                   (response) => {
  //                     if (response.status === 200) {
  //                       localStorage.setItem(
  //                         "subPlan",
  //                         JSON.stringify(response.data)
  //                       );
  //                     }
  //                   }
  //                 );

  //                 localStorage.setItem("plan", JSON.stringify(plan));
  //                 history.push({
  //                   pathname: "/OrderSummary",
  //                   // state: { plan }
  //                 });
  //               }
  //             });
  //           }
  //         }
  //         // }

  //         // else

  //         // {
  //         //   // User is verified
  //         //   const plan = planId;
  //         //   localStorage.setItem("plan", JSON.stringify(plan));
  //         //   history.push({
  //         //     pathname: "/OrderSummary",
  //         //     // state: { plan }
  //         //   });
  //         // }
  //       });
  //     } else {
  //       localStorage.clear();
  //       history.push("/");
  //     }
  //   }
  //   // else {
  //   //   const plan = planId
  //   //   history.push({
  //   //     pathname: '/OrderSummary',
  //   //     state: { plan }
  //   //   });

  //   // }
  // };

  const [showTopup, setShowTopUp] = useState(false);
  const [goAheadClicked, setGoAheadClicked] = useState(false);
  // const [topUpPlan, setTopUpPlan] = useState(null);
  const [esimPlanRecharge, setEsimPlanRecharge] = useState(null);

  const topUpClicked = (plan) => {
    const foundPlan = esimPlanTopUp.find(
      (p) => p.esimPlan?.plan?.planId === plan.planId
    );

    if (foundPlan != null) {
      const esimPlanRecharge = foundPlan.esimPlan.esimPlanRecharge[0];
      if (
        esimPlanRecharge.dataRemainingInMb > 0 &&
        esimPlanRecharge.dataStatus !== "TERMINATED"
      ) {
        setTopUpPlan(foundPlan);
        setEsimPlanRecharge(esimPlanRecharge);
        setShowTopUp(true);

        localStorage.setItem("plan", JSON.stringify(plan));
      } else {
        topupClicked1(plan);
      }
    }
  };

  const updateLoginPopupStatus = () => {
    setShowLoginPopUp(false);
  };
  const closeTopUpAlert = () => {
    setShowTopUp(false);
    localStorage.removeItem("plan");
  };
  const updateVarificationPopupStatus = () => {
    setShowVerifyPopup(false);
  };

  const proceedClicked = () => {
    history.push({
      pathname: "/OrderSummary",
      // state: { plan }
    });
  };

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  useEffect(() => {
    filterPlans();
  }, [searchText, userPlans]);

  const loginClicked = () => {
    history.push(`/login`);
  };

  const resendClicked = () => {
    const revarification = localStorage.getItem("emailId");
    UserVarificationService.resendVerificationLink(revarification).then(
      (response) => {
        if (response.status == 200) {
          setShowVerifyPopup(false);
        }
      }
    );
  };
  const ProceedAndCancelBtn = () => {
    return (
      <div className="w-100 d-flex justify-content-between align-items-center">
        <button
          className="btn btn-danger rounded-pill text-uppercase btn-md notranslate"
          onClick={() => closeTopUpAlert()}
        >
          CANCEL
        </button>
        <button
          className="btn rounded-pill text-uppercase btn-success btn-md notranslate"
          onClick={() => proceedClicked()}
        >
          PROCEED ANYWAY
        </button>
      </div>
    );
  };

  const LoginCtaBtn = () => {
    return (
      <button
        className="btn rounded-pill font-weight-bold text-uppercase btn-dark custom-width-btn btn-md mt-2 mb-1 notranslate"
        onClick={loginClicked}
      >
        LOGIN
      </button>
    );
  };

  const ResendEmailBtn = () => {
    return (
      <button
        className="btn rounded-pill font-weight-bold text-uppercase btn-dark custom-width-btn btn-md mt-2 mb-1 notranslate"
        onClick={resendClicked}
      >
        RESEND EMAIL
      </button>
    );
  };

  const [selectedPlan, setSelectedPlan] = useState(null);
  const [topUpPlan, setTopUpPlan] = useState();

  const [esimPlanTopUp, setEsimPlanTopUp] = useState([]);
  useEffect(() => {
    // setIsLoading(true);
    // Retrieve the planId from the URL parameter
    const topUpList = localStorage.getItem("topUpList");
    const esimPlanTopUp = JSON.parse(topUpList) || [];
    // const esimPlanTopUp = JSON.parse(topUpList);

    setEsimPlanTopUp(esimPlanTopUp);
    const plan1String = localStorage.getItem("topUpIccid");

    if (plan1String != undefined && plan1String != "") {
      const plan1 = JSON.parse(plan1String);
      // const planId = plan1.esimPlan.plan.planId.toString();

      // Assuming 'plan' is an array containing plan objects
      // const foundPlan = plan.find((p) => p.planId.toString() === planId);
      // Update the selectedPlan state
      setSelectedPlan(plan1 != undefined ? plan1 : []);
    }
  }, [props.match.params.planId, plan]);

  useEffect(() => {
    if (selectedPlan !== undefined && selectedPlan !== null) {
      // setIsLoading(false);
    }
  }, [selectedPlan]);

  useEffect(() => {
    // setIsLoading(true);
    if (!props.match.params.planId) {
      // Retrieve the planId from the URL parameter
      localStorage.removeItem("topUpIccid");
      localStorage.removeItem("myEsimList");
      localStorage.removeItem("topUpList");
    }
    // setIsLoading(false);
  }, [props.match.params.planId, plan]);

  const handleDetailsOpen = (data) => {
    setDetailsOpen(true);
    setCurrentDetails(data);
  };

  const handleDetailsClose = () => {
    setDetailsOpen(false);
    setCurrentDetails({});
  };

  const openModalDropdown = (res) => {
    // setModalDropdown(true);
  };

  const topupClicked1 = (data) => {
    localStorage.setItem("plan", JSON.stringify(data));
    history.push({
      pathname: "/OrderSummary",
    });
  };

  // google analytics

  // useEffect(() => {
  //   document.querySelector('title').classList.add('notranslate');
  //   document.title = `eROAMING eSIM Plans Page/${props.match.params.alpha2 ? props.match.params.alpha2 : props.match.params.regionId ? props.match.params.regionId : "Global"}`;
  // }, []);

  useEffect(() => {
    // Create a script element
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-CNPPGN8KCG";

    // Append the script to the document body
    document.body.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-CNPPGN8KCG');
    gtag('user_id', localStorage.getItem("ip"));

    // Clean up function to remove the script when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []); // Empty dependency array ensures that this effect runs only once

  // useEffect(() => {
  //   document.querySelector('title').classList.add('notranslate');
  // document.title = `eROAMING eSIM Plans Page/${
  //   props.match.params.alpha2
  //     ? props.match.params.alpha2
  //     : props.match.params.regionId
  //     ? props.match.params.regionId
  //     : "Global"
  // }`;
  // }, []);

  useEffect(() => {
    const combine = [...metaDataRegion, ...metaDataCountry];

    if (combine) {
      const countryTitle = metaDataCountry.find(
        (comb) => comb.alpha2 == props.match.params.alpha2
      )?.title;
      const regionTitle = metaDataRegion.find(
        (comb) => comb.regionId == props.match.params.regionId
      )?.title;

      const countryDescription = metaDataCountry.find(
        (comb) => comb.alpha2 == props.match.params.alpha2
      )?.description;
      const regionDescription = metaDataRegion.find(
        (comb) => comb.regionId == props.match.params.regionId
      )?.description;

      const countryKeywords = metaDataCountry.find(
        (comb) => comb.alpha2 == props.match.params.alpha2
      )?.keywords;
      const regionKeywords = metaDataRegion.find(
        (comb) => comb.regionId == props.match.params.regionId
      )?.keywords;

      const metaContent = {
        charset: "utf-8",
        title:
          countryTitle !== undefined
            ? countryTitle
            : regionTitle !== undefined
              ? regionTitle
              : "eROAMING eSIM Plans",
        description:
          countryDescription !== undefined
            ? countryDescription
            : regionDescription !== undefined
              ? regionDescription
              : "eROAMING eSIM Plans",
        keywords:
          countryKeywords !== undefined
            ? countryKeywords
            : regionKeywords !== undefined
              ? regionKeywords
              : "eROAMING eSIM Plans",
      };
      if (metaContent.title !== undefined) {
        setMetaTagInfo(metaContent);
      }
      // setIsLoading(false);
    }

    // const metaContent = {
    //   charset: "utf-8",
    //   title: "title",
    //   description: planPageCountry
    //     ? planPageCountry == "China"
    //       ? "Enjoy fast, roaming-free mobile data in China with eSIM Mobile. Explore flexible eSIM plans and get free eSIM data for seamless connectivity."
    //       : planPageCountry == "United Kingdom"
    //       ? "Get the best eSIM data plans in the UK with eSIM Mobile. Explore top eSIM providers and buy your eSIM for seamless connectivity."
    //       : "eROAMING eSIM Plans"
    //     : planPageRegion
    //     ? planPageRegion == "Middle East"
    //       ? "Get fast, roaming-free mobile data in the UAE with eSIM Mobile. Explore flexible eSIM plans and enjoy free eSIM data for seamless connectivity."
    //       : "eROAMING eSIM Plans"
    //     : "eROAMING eSIM Plans",
    //   keywords: planPageCountry
    //     ? planPageCountry == "China"
    //       ? "Flexible eSIM plans China, Free eSIM Data China, Fast mobile data China, Roaming-free data China"
    //       : planPageCountry == "United Kingdom"
    //       ? "Buy eSIM UK, eSIM plans UK, eSIM providers UK, Best eSIM data plans"
    //       : "eROAMING eSIM Plans"
    //     : planPageRegion
    //     ? planPageRegion == "Middle East"
    //       ? "Flexible eSIM plans UAE, Free eSIM Data UAE, Fast mobile data UAE, Roaming-free data UAE"
    //       : "eROAMING eSIM Plans"
    //     : "eROAMING eSIM Plans",
    // };
  }, [metaDataRegion, metaDataCountry]);

  const updateKycPopupStatus = () => {
    setShoweKycPopup(false);
  };

  const CoverageDropdownForDetails = ({ index, planCountry }) => {
    let [country, setCountry] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredCountries, setFilteredCountries] = useState([]);
    useEffect(() => {
      if (planCountry !== null && index !== null) {
        setCountry(planCountry[index].coverage);
      }
    }, []);

    useEffect(() => {
      const filtered = country.filter((item) =>
        item.countryDescription
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
      );
      setFilteredCountries(filtered);
    }, [searchTerm, country]);

    const handleSearchChange = (event) => {
      setSearchTerm(event.target.value);
    };

    return (
      <div className="dropdowns-modal">
        <div className="coverage-dropdown">
          <div className="w-100" ref={detailsCoverageDropdownRef}>
            <h4>
              Coverage is provided by <span>{country.length}</span>{" "}
              {country.length > 1 ? "countries" : "country"}
            </h4>
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <div className="coverage-dropdown-list mt-2 notranslate">
              <ul>
                {searchTerm && filteredCountries.length === 0 ? (
                  <li className="no-results">No results found</li>
                ) : (
                  filteredCountries.map((item, index) => (
                    <li key={index}>
                      <div
                        style={{ gap: "10px" }}
                        className="d-flex justify-content-between align-items-center"
                      >
                        <div className="d-flex justify-content-center align-items-center">
                          <div>
                            <span
                              key={index}
                              className={`fflag fflag-${item.alpha2} ff-lg ff-round`}
                            ></span>
                          </div>
                          <div className="ml-2">
                            <p style={{ lineHeight: "1" }}>
                              {item.countryDescription}
                              {currentDetails?.vendor?.vendorId ==
                                NETWORK3_VENDOR &&
                                item.sanction && (
                                  <span className="sanctioned-badge">
                                    sanctioned
                                  </span>
                                )}
                            </p>
                          </div>
                        </div>
                        {item.planCountryNetwork !== null ? (
                          <div className="d-flex flex-column justify-content-center align-items-end">
                            {item.planCountryNetwork.map(
                              (network, networkIndex) => (
                                <span key={networkIndex}>{network}</span>
                              )
                            )}
                          </div>
                        ) : (
                          <div className="d-flex flex-column justify-content-center align-items-end">
                            <span></span>
                          </div>
                        )}
                      </div>
                    </li>
                  ))
                )}
              </ul>
            </div>
          </div>
          <SlClose className="modal-close-icon" />
        </div>
      </div>
    );
  };

  const openCoverageDropdownForDetails = (index, globalId) => {
    setIsCoverageDropdownOpenForDetails(true);
    setIndexForDetailsDropdown(index);
    // setGlobalCountryTicketIndex(index);
    document.body.style.overflowY = "hidden";
  };
  const closeCoverageDropdownForDetails = () => {
    setIsCoverageDropdownOpenForDetails(false);
    document.body.style.overflowY = "auto";
  };

  const handleCoverageClickForDetails = (event) => {
    if (
      isCoverageDropdownOpenForDetails &&
      detailsCoverageDropdownRef.current &&
      !detailsCoverageDropdownRef.current.contains(event.target)
    ) {
      closeCoverageDropdownForDetails();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleCoverageClickForDetails);

    return () => {
      document.removeEventListener("click", handleCoverageClickForDetails);
    };
  }, [isCoverageDropdownOpenForDetails]);

  const [filteredData, setFilteredData] = useState([]);
  useEffect(() => {
    if (
      currentDetails !== undefined &&
      currentDetails !== null &&
      Object.keys(currentDetails).length > 0
    ) {
      const networkOverideSampleData = [
        {
          id: 1,
          type: "Data",
          service: "Bandwidth",
          definition: "Data can only be used in country",
          example: "If country = USA: Data can only be used in the USA.",
          coverage: ["<currentCountry>"],
          planCategoryIds: [DATA_ONLY, DATA_CALLS_SMS],
        },
        {
          id: 2,
          type: "Voice",
          service: "Outgoing",
          definition: "Calls can only be made from the coverage country.",
          example:
            "If country = USA: Voice calls can only be made from the USA.",
          coverage: ["<currentCountry>"],
          planCategoryIds: [CALLS_AND_SMS, DATA_CALLS_SMS],
        },
        {
          id: 3,
          type: "Voice",
          service: "Incoming",
          definition: "Calls can only be received in the specified country.",
          example:
            "If country = UK: Voice calls can only be received in the UK.",
          coverage: ["<currentCountry>"],
          planCategoryIds: [CALLS_AND_SMS, DATA_CALLS_SMS],
        },
        {
          id: 4,
          type: "Voice",
          service: "To Country",
          definition: "Calls can only be made to the specified country.",
          example:
            "If country = France: Voice calls can only be made to France.",
          coverage: ["<currentCountry>"],
          planCategoryIds: [CALLS_AND_SMS, DATA_CALLS_SMS],
        },
        {
          id: 5,
          type: "SMS",
          service: "Outgoing",
          definition: "SMS can only be sent from the specified country.",
          example: "If country = Germany: SMS can only be sent from Germany.",
          coverage: ["<currentCountry>"],
          planCategoryIds: [CALLS_AND_SMS, DATA_CALLS_SMS],
        },
        {
          id: 6,
          type: "SMS",
          service: "Incoming",
          definition: "SMS can only be received in the specified country.",
          example: "If country = Italy: SMS can only be received in Italy.",
          coverage: ["<currentCountry>"],
          planCategoryIds: [CALLS_AND_SMS, DATA_CALLS_SMS],
        },
        {
          id: 7,
          type: "SMS",
          service: "To Country",
          definition: "SMS can only be sent to the specified country.",
          example: "If country = Japan: SMS can only be sent to Japan.",
          coverage: ["<currentCountry>"],
          planCategoryIds: [CALLS_AND_SMS, DATA_CALLS_SMS],
        },
      ];

      const planCategoryId = currentDetails?.planCategory?.planCategoryId || 0;
      const getCoverage = (id, planTypeId) => {
        const arr = currentDetails.planCountry;
        if (currentDetails.vendor.vendorId == NETWORK3_VENDOR) {
          return arr
            .filter((item) => {
              const hasDataOnly = id == 1 && item.hasDataOnly;
              const hasVoiceO = id == 2 && item.hasVoiceO;
              const hasVoiceT = id == 3 && item.hasVoiceT;
              const hasVoiceB = id == 4 && item.hasVoiceB;
              const hasSMSO = id == 5 && item.hasSMSO;
              const hasSMST = id == 6 && item.hasSMST;
              const hasSMSB = id == 7 && item.hasSMSB;
              // Adjust the conditions as needed
              return (
                hasDataOnly ||
                hasVoiceO ||
                hasVoiceB ||
                hasVoiceT ||
                hasSMSO ||
                hasSMSB ||
                hasSMST
              );
            })
            .map((country) => country);
        } else {
          return arr;
        }
      };

      const filtered = networkOverideSampleData
        .filter(
          (item) =>
            Array.isArray(item.planCategoryIds) &&
            item.planCategoryIds.includes(planCategoryId)
        )
        .map((item) => ({
          ...item,
          coverage: getCoverage(item.id, currentDetails?.planType?.planTypeId),
        }));
      setFilteredData(filtered);
    }
  }, [currentDetails]);

  function convertToMB(value) {
    if (!value) return 0; // Handle undefined or null cases
    const match = value.match(/([\d.]+)\s*(MB|GB)/i);
    if (!match) return 0; // If format is incorrect, return 0

    let number = parseFloat(match[1]);
    let unit = match[2].toUpperCase();

    return unit === "GB" ? number * 1024 : number; // Convert GB to MB
  }

  const fetchCountryInfo = async (country) => {
    setRegionInfo("");
    setPlanPageRegion();
    // setIsLoading(true);
    try {
      const response = await axios.get(
        `https://restcountries.com/v3.1/alpha/${country}`
      );
      setCountryInfo(response.data[0]);
      setPlanPageCountry(response?.data[0]?.name?.common);
      // setIsLoading(false);
    } catch (error) {
      setCountryInfoError("No information available");
      // setIsLoading(false);
    }
  };

  const fetchRegionInfo = async (region) => {
    setCountryInfo({});
    setPlanPageCountry();
    setPlanPageRegion(region);
    switch (region) {
      case "Africa":
        setRegionInfo(
          "Africa is the second-largest and second-most-populous continent on Earth, covering approximately 30.37 million km² (11.7 million mi²) and home to over 1.4 billion people. It is known for its vast cultural diversity, rich natural resources, and unique ecosystems."
        );
        break;
      case "Asia":
        setRegionInfo(
          "Asia is the largest and most populous continent, covering about 44.58 million km² (17.2 million mi²) and home to over 4.7 billion people, making up nearly 60% of the world's population. It is known for its vast geographic diversity, ancient civilizations, and rapid economic growth."
        );
        break;
      case "Europe":
        setRegionInfo(
          "Europe is the sixth-largest continent by land area but the third-most populous, covering about 10.18 million km² (3.93 million mi²) and home to approximately 750 million people. It is known for its rich history, cultural diversity, and economic power."
        );
        break;
      case "Caribbean":
        setRegionInfo(
          "The Caribbean is a region consisting of islands and coastal territories in the Caribbean Sea, located between North and South America. It is known for its tropical climate, vibrant cultures, and tourism-driven economies. The region includes over 700 islands, islets, and cays, with a total population of approximately 44 million people."
        );
        break;
      case "Latin America":
        setRegionInfo(
          "Latin America is a culturally and geographically diverse region consisting of countries in Central America, South America, and parts of North America where Spanish, Portuguese, and French are predominantly spoken. It has a total area of approximately 19.2 million km² (7.4 million mi²) and a population of around 670 million people."
        );
        break;
      case "Balkans":
        setRegionInfo(
          "The Balkans, or Balkan Peninsula, is a region in Southeastern Europe known for its diverse cultures, complex history, and significant geopolitical influence. It covers approximately 470,000 km² (181,000 mi²) and has a population of around 55 million people. The region has been shaped by various civilizations, including the Romans, Byzantines, Ottomans, and Austro-Hungarians."
        );
        break;
      case "Caucasus":
        setRegionInfo(
          "The Caucasus is a region located at the crossroads of Europe and Asia, between the Black Sea and the Caspian Sea. It is known for its ethnic diversity, mountainous landscapes, and strategic geopolitical importance. The region covers approximately 440,000 km² (170,000 mi²) and has a population of around 25 million people."
        );
        break;
      case "Middle East":
        setRegionInfo(
          "The Middle East is a region that spans Western Asia and parts of North Africa, known for its rich history, cultural diversity, and economic significance due to its vast oil and gas reserves. It covers approximately 7.2 million km² (2.8 million mi²) and has a population of around 450 million people."
        );
        break;

      default:
        break;
    }

    // setIsLoading(true);
    // try {
    //   const response = await axios.get(
    //     `https://restcountries.com/v3.1/region/${region}`
    //   );
    //   // setCountryInfo(response.data[0]);
    // } catch (error) {
    //   setRegionInfo("No information available");
    //   // setIsLoading(false);
    // }
  };

  useEffect(() => {
    const { alpha2, regionId } = props.match.params;

    if (alpha2) {
      fetchCountryInfo(alpha2);
    } else if (regionId) {
      const regionMap = {
        1: "Africa",
        4: "Asia",
        5: "Europe",
        7: "Caribbean",
        8: "Latin America",
        9: "Balkans",
        10: "Caucasus",
        11: "Middle East",
      };

      if (regionMap[regionId]) {
        fetchRegionInfo(regionMap[regionId]);
      }
    }
  }, [props.match.params.alpha2, props.match.params.regionId]);

  function formatPopulation(number) {
    if (number == null || isNaN(number)) {
      return "N/A"; // Handle undefined, null, or non-numeric values
    }

    if (number >= 1_000_000_000) {
      return (number / 1_000_000_000).toFixed(2) + " billion";
    } else if (number >= 1_000_000) {
      return (number / 1_000_000).toFixed(2) + " million";
    } else if (number >= 1_000) {
      return (number / 1_000).toFixed(0) + "K";
    } else {
      return number.toString(); // Ensure it's a string
    }
  }

  function getFirstElement(obj) {
    if (Array.isArray(obj)) {
      return obj[0]; // First element of an array
    } else if (typeof obj === "object" && obj !== null) {
      return obj[Object.keys(obj)[0]]; // First value in an object
    }
    return undefined; // Return undefined for other types
  }

  return (
    <div className="plan-section notranslate">
      <Helmet>
        <meta charSet={metaTagInfo.charset} />
        <title>{metaTagInfo.title}</title>
        <meta name="description" content={metaTagInfo.description} />
        <meta name="keywords" content={metaTagInfo.keywords} />
      </Helmet>
      <Header />

      {/*header search bar  */}
      <div className="container position-relative">
        {location.pathname.includes("plan-details") === true ? (
          <>
            <section className="table-section container mb-3 notranslate">
              <div className="row">
                {imageLoaded && (
                  <div className="col-12 col-md-6 pt-2">
                    <div
                      className={`bg-img `}
                      style={{
                        backgroundImage: `url(${countryBg
                            ? countryBg
                            : "https://images.unsplash.com/photo-1451187580459-43490279c0fa?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w0NzcxNDJ8MHwxfHNlYXJjaHwzfHxnbG9iYWx8ZW58MHx8fHwxNzI2NzQ1MDY1fDA&ixlib=rb-4.0.3&q=80&w=300"
                          })`,
                      }}
                    ></div>
                  </div>
                )}
                <div className="col-12 col-md-6">
                  <>
                    <div
                      className="d-flex align-items-center mb-2 mt-2"
                      style={{ gap: "8px" }}
                    >
                      {props.match.params.alpha2 ? (
                        <span
                          className={`fflag fflag-${props.match.params.alpha2} ff-lg ff-round`}
                        ></span>
                      ) : (
                        <span
                          className={`${countryOrRegion == "Europe" ? "fflag-EU" : ""
                            } fflag ff-lg ff-round`}
                        >
                          {countryOrRegion != "Europe" ? (
                            <img
                              style={{ width: "24px", height: "24px" }}
                              className="regionLogo"
                              src={
                                countryOrRegion == "Africa"
                                  ? Africa
                                  : countryOrRegion == "Asia"
                                    ? Asia
                                    : countryOrRegion == "Australia"
                                      ? Australia
                                      : countryOrRegion == "Caribbean"
                                        ? Caribbean
                                        : countryOrRegion == "Latin America"
                                          ? LatinAmerica
                                          : countryOrRegion == "Balkans"
                                            ? Balkans
                                            : countryOrRegion == "Caucasus"
                                              ? Caucasus
                                              : countryOrRegion == "Middle East"
                                                ? MiddleEast
                                                : countryOrRegion == "T20 WC Region 1"
                                                  ? t20WcIcon
                                                  : countryOrRegion == "T20 WC Region 2"
                                                    ? t20WcIcon
                                                    : !props.match.params.regionId &&
                                                      !props.match.params.alpha2
                                                      ? World
                                                      : null
                              }
                            />
                          ) : (
                            ""
                          )}
                        </span>
                      )}
                      <h2 className="font-weight-bold mb-0">
                        {planPageCountry
                          ? countryInfo?.name?.common
                          : planPageRegion
                            ? planPageRegion
                            : null}
                      </h2>
                    </div>
                    {planPageCountry ? (
                      <p>
                        {countryInfo?.name?.common}, officially known as the{" "}
                        {countryInfo?.name?.official}, This country is in{" "}
                        {countryInfo?.subregion} with as its capital. It has a
                        population of over{" "}
                        {formatPopulation(countryInfo?.population)} people and
                        uses the{" "}
                        {getFirstElement(countryInfo?.currencies)?.name}{" "}
                        {getFirstElement(countryInfo?.currencies)?.symbol} as
                        its currency.
                      </p>
                    ) : planPageRegion ? (
                      <p>{regionInfo}</p>
                    ) : null}
                  </>
                </div>
              </div>
            </section>
            <section className="d-flex flex-column justify-content-center align-items-center">
              <div id="table-section" className="table-section">
                <CustomFilterSection
                  onFilterChange={handleFilterChange}
                  searchText={searchText}
                  handleSearchChange={handleSearchChange}
                  onCheapestFilterClick={handleCheapestFilterClick}
                  onBestPricePerGBFilterClick={handleBestPricePerGBFilterClick}
                  onUnlimitedToggle={handleUnlimitedToggle}
                  unlimitedFilter={unlimitedFilter}
                  onFilterRemove={() => {
                    props.match.params.regionId
                      ? regionPlansAPI()
                      : props.match.params.alpha2
                        ? plansAPI()
                        : globalPlansAPI();
                  }}
                  onFilterRemoveForOthers={() => {
                    forUnlimitedPlans.length !== 0
                      ? unlimitedToggle()
                      : props.match.params.regionId
                        ? regionPlansAPI()
                        : props.match.params.alpha2
                          ? plansAPI()
                          : globalPlansAPI();
                  }}
                  onLongestValidityFilterClick={
                    handleLongestValidityFilterClick
                  }
                  onLargestGBFilterClick={handleLargestGBFilterClick}
                  onUnlimitedFilterToggle={unlimitedToggle}
                />
                <CSmartTable
                  clickableRows
                  columns={columns}
                  items={filteredPlans}
                  pagination
                  scopedColumns={{
                    avatar: (item) => (
                      <td>
                        <CAvatar src={logo} />
                      </td>
                    ),
                    // show_Buy: (item, rowIndex) => {
                    //   return (
                    //     <td className="py-2" style={{ textAlign: "center" }}>
                    //       {item.planId &&
                    //       esimPlanTopUp &&
                    //       esimPlanTopUp.some(
                    //         (topUp) =>
                    //           topUp.esimPlan.plan.planId === item.planId.planId
                    //       ) ? (
                    //         <CButton
                    //           className="table-view-more-btn"
                    //           color="light"
                    //           variant="outline"
                    //           shape="square"
                    //           size="sm"
                    //           onClick={() => {
                    //             topUpClicked(item.planId, rowIndex);
                    //           }}
                    //         >
                    //           {buy ? "TOP UP" : "TOP UP"}
                    //         </CButton>
                    //       ) : (
                    //         <CButton
                    //           className="table-view-more-btn"
                    //           color="light"
                    //           variant="outline"
                    //           shape="square"
                    //           size="sm"
                    //           // onClick={() => {
                    //           //   toggleBuy(item.planId, rowIndex);
                    //           // }}
                    //         >
                    //           {buy ? "Buy Now" : "Buy Now"}
                    //         </CButton>
                    //       )}
                    //     </td>
                    //   );
                    // },
                    // details: (item, rowIndex) => {
                    //   return (
                    //     <CCollapse visible={detailsState[rowIndex]}>
                    //       <CCardBody className="p-3">
                    //         <h4>{item.username}</h4>
                    //         <p className="text-muted">
                    //           User since: {item.PLANNAME}
                    //         </p>
                    //         <CButton size="sm" color="info">
                    //           User Settings
                    //         </CButton>
                    //         <CButton size="sm" color="danger" className="ml-1">
                    //           Delete
                    //         </CButton>
                    //       </CCardBody>
                    //     </CCollapse>
                    //   );
                    // },
                  }}
                  tableProps={{
                    className: "add-this-className",
                    responsive: true,
                    striped: true,
                    hover: true,
                  }}
                  tableBodyProps={{
                    className: "align-middle",
                  }}
                />
              </div>
            </section>
          </>
        ) : location.pathname.includes("topup") === true ? (
          <>
            <div className="top-up-grid mb-3">
              <div className={`card-ticket popular-sticker text-white`}>
                <div className="golden-label d-flex align-items-center">
                  <span className="d-inline-block text-truncate number">
                    Last Recharge
                  </span>
                </div>
                {selectedPlan != null && (
                  <div
                    className="w-100 light-ThemeTopup"
                    style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}
                  >
                    <div className="pl-1">
                      <h2 className="number mt-2 mb-0 plan-detail">
                        {selectedPlan?.esimPlan?.plan?.data}
                      </h2>
                      <p className="number">
                        {selectedPlan?.esimPlan?.plan?.planName}
                      </p>
                      <div className="mt-3 d-flex justify-content-between align-items-center">
                        <div className="plan-validity">
                          <p className="number card-content">
                            {selectedPlan?.esimPlan?.plan?.bundleType
                              .bundleTypeId === RECURRING_BUNDLE_ID
                              ? selectedPlan?.esimPlan?.plan?.recurringMonth +
                              " Months"
                              : selectedPlan?.esimPlan?.plan?.validity +
                              " Days"}
                          </p>
                          <p className="muted-text">validity</p>
                        </div>
                        <div className="line-seperator"></div>
                        <div className="plan-price">
                          <p className="number card-content">
                            {selectedPlan?.esimPlan?.plan?.bundleType
                              ?.bundleTypeId == RECURRING_BUNDLE_ID
                              ? `£${Number(
                                selectedPlan?.esimPlan?.plan
                                  ?.recurringMonthlyAmount *
                                selectedPlan?.esimPlan?.plan?.recurringMonth
                              ).toFixed(2)}`
                              : `£${Number(
                                selectedPlan?.esimPlan?.plan?.price
                              ).toFixed(2)}`}
                          </p>
                          <p className="muted-text">price</p>
                        </div>
                      </div>
                    </div>
                    {(selectedPlan?.esimPlan?.plan?.planCategory
                      ?.planCategoryId === DATA_ONLY ||
                      selectedPlan?.esimPlan?.plan?.planCategory
                        ?.planCategoryId === DATA_CALLS_SMS) && (
                        <div className="d-flex justify-content-center align-items-center mt-2">
                          <div className="circular-progress">
                            <div className="progress-text notranslate">
                              <span>
                                <b style={{ fontWeight: 700 }}>
                                  {
                                    selectedPlan?.esimPlan?.esimPlanRecharge[0]
                                      ?.dataUsed
                                  }
                                </b>
                              </span>
                              <br />
                              <span>
                                /
                                {
                                  selectedPlan?.esimPlan?.esimPlanRecharge[0]
                                    ?.totalData
                                }
                              </span>
                            </div>
                            <CircularProgressbar
                              value={convertToMB(
                                selectedPlan?.esimPlan?.esimPlanRecharge[0]
                                  ?.dataUsed
                              )}
                              maxValue={convertToMB(
                                selectedPlan?.esimPlan?.esimPlanRecharge[0]
                                  ?.totalData
                              )}
                              styles={buildStyles({
                                rotation: 0.5,
                                strokeLinecap: "butt",
                                textSize: "16px",
                                pathTransitionDuration: 0.2,
                                pathColor: `#fff`,
                                textColor: "#fff",
                                trailColor: "#d2004c",
                              })}
                            />
                          </div>
                        </div>
                      )}
                  </div>
                )}
                {selectedPlan?.esimPlan?.plan.active == 1 &&
                  selectedPlan?.esimPlan?.plan.activeApproved == 1 ? (
                  <button
                    className="btn btn-light notranslate"
                    onClick={() => topUpClicked(selectedPlan?.esimPlan?.plan)}
                  >
                    TOP UP
                  </button>
                ) : (
                  <div></div>
                )}
              </div>
              <div
                style={{ minHeight: "auto" }}
                className="card-ticket position-relative p-3"
              >
                <div style={{ paddingRight: "150px" }}>
                  <h4 className="mt-1 font-weight-bold">
                    Find the best Local & Regional eSIM
                  </h4>
                  <p>Search over 10,000+ eSIM data plans in 200+ countries</p>
                  <button
                    onClick={() => history.push("/")}
                    className="btn btn-custom-gradient shadow-sm btn-sm mt-3"
                  >
                    Explore
                  </button>
                </div>
                <img
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "35px",
                    transform: "translateY(-50%)",
                  }}
                  src={advtSticker}
                  alt=""
                />
              </div>
            </div>
            <div
              style={{ gap: "6px" }}
              className="d-flex align-items-center mb-2"
            >
              <img width={20} src={star} alt="" />
              <h4 className="mb-0">All Recomended Plans</h4>
            </div>
            {selectedPlan?.esimPlan?.plan?.vendor?.vendorId === MAYA_VENDOR ? (
              selectedPlan?.esimPlan?.plan?.planType?.planTypeId ===
                PLAN_TYPE_LOCAL ? (
                <PlansTray
                  hideBack={true}
                  setShowPlansTray={setShowPlansTray}
                  setRecurringModal={setRecurringModal}
                  recurringModal={recurringModal}
                  selected={selectedPlan?.esimPlan?.plan?.country}
                  tab={"1"}
                  setModalData={setModalData}
                  setDetailsOpen={setDetailsOpen}
                  setCurrentDetails={setCurrentDetails}
                  setSubPlan={setSubPlan}
                  subPlan={subPlan}
                  isTopPlan={true}
                  vendorId={selectedPlan?.esimPlan?.plan?.vendor.vendorId}
                  setShoweKycPopup={setShoweKycPopup}
                  resetTheFilterValue={resetTheFilterValue}
                  setResetTheFilterValue={setResetTheFilterValue}
                />
              ) : selectedPlan?.esimPlan?.plan?.planType?.planTypeId ===
                PLAN_TYPE_REGIONAL ? (
                <PlansTray
                  hideBack={true}
                  setShowPlansTray={setShowPlansTray}
                  setRecurringModal={setRecurringModal}
                  recurringModal={recurringModal}
                  selected={selectedPlan?.esimPlan?.plan?.region}
                  tab={"2"}
                  setModalData={setModalData}
                  setDetailsOpen={setDetailsOpen}
                  setCurrentDetails={setCurrentDetails}
                  setSubPlan={setSubPlan}
                  subPlan={subPlan}
                  isTopPlan={true}
                  vendorId={selectedPlan?.esimPlan?.plan?.vendor.vendorId}
                  setShoweKycPopup={setShoweKycPopup}
                  resetTheFilterValue={resetTheFilterValue}
                  setResetTheFilterValue={setResetTheFilterValue}
                />
              ) : (
                selectedPlan?.esimPlan?.plan?.planType?.planTypeId ===
                PLAN_TYPE_GLOBAL && (
                  <PlansTray
                    hideBack={true}
                    setShowPlansTray={setShowPlansTray}
                    setRecurringModal={setRecurringModal}
                    recurringModal={recurringModal}
                    selected={selectedPlan?.esimPlan?.plan?.globalCategory}
                    tab={"3"}
                    setModalData={setModalData}
                    setDetailsOpen={setDetailsOpen}
                    setCurrentDetails={setCurrentDetails}
                    setSubPlan={setSubPlan}
                    subPlan={subPlan}
                    isTopPlan={true}
                    vendorId={selectedPlan?.esimPlan?.plan?.vendor.vendorId}
                    setShoweKycPopup={setShoweKycPopup}
                    resetTheFilterValue={resetTheFilterValue}
                    setResetTheFilterValue={setResetTheFilterValue}
                  />
                )
              )
            ) : (
              <div className="container position-relative destination-tabs mt-3 px-1 px-md-0">
                <Tabs
                  options={options}
                  value={{ value: 1, label: "Local eSIM" }}
                  onChange={onChangeTabsHandler}
                  renderTab={renderTab}
                  currentTab={currentTab}
                />
                <div className="tabs-slider">
                  <div
                    className="tabs-indicator"
                    style={{
                      left: `${indicatoPosition}px`,
                      width: `${currentTabWidth + (screenWidth < 992 ? 20 : 100)
                        }px`,
                    }}
                  ></div>
                </div>
                <div className="tabs__content">
                  {currentTab.value === PLAN_TYPE_LOCAL ? (
                    <LocalESim
                      isTopPlan={true}
                      vendorId={selectedPlan?.esimPlan?.plan?.vendor.vendorId}
                      suggestion={suggestionCountryPlanPage}
                      setRecurringModal={setRecurringModal}
                      recurringModal={recurringModal}
                      setSubPlan={setSubPlan}
                      subPlan={subPlan}
                      setModalData={setModalData}
                      setCurrentDetails={setCurrentDetails}
                      setDetailsOpen={setDetailsOpen}
                      setShoweKycPopup={setShoweKycPopup}
                      resetTheFilterValue={resetTheFilterValue}
                      setResetTheFilterValue={setResetTheFilterValue}
                    />
                  ) : currentTab.value === PLAN_TYPE_REGIONAL ? (
                    <RegionalESim
                      isTopPlan={true}
                      vendorId={selectedPlan?.esimPlan?.plan?.vendor.vendorId}
                      suggestion={suggestionRegionPlanPage}
                      setRecurringModal={setRecurringModal}
                      recurringModal={recurringModal}
                      setModalData={setModalData}
                      setSubPlan={setSubPlan}
                      subPlan={subPlan}
                      openCoverageDropdown={openCoverageDropdown}
                      setCurrentDetails={setCurrentDetails}
                      setDetailsOpen={setDetailsOpen}
                      setShoweKycPopup={setShoweKycPopup}
                      resetTheFilterValue={resetTheFilterValue}
                      setResetTheFilterValue={setResetTheFilterValue}
                    />
                  ) : currentTab.value === PLAN_TYPE_GLOBAL ? (
                    <GlobalESim
                      isTopPlan={true}
                      vendorId={selectedPlan?.esimPlan?.plan?.vendor.vendorId}
                      suggestion={suggestionGlobalPlanPage}
                      setRecurringModal={setRecurringModal}
                      recurringModal={recurringModal}
                      setModalData={setModalData}
                      setSubPlan={setSubPlan}
                      subPlan={subPlan}
                      openCoverageDropdownForGlobal={
                        openCoverageDropdownForGlobal
                      }
                      globalCountries={globalCountries}
                      setCurrentDetails={setCurrentDetails}
                      setDetailsOpen={setDetailsOpen}
                      setShoweKycPopup={setShoweKycPopup}
                      resetTheFilterValue={resetTheFilterValue}
                      setResetTheFilterValue={setResetTheFilterValue}
                    />
                  ) : null}
                </div>
              </div>
            )}
          </>
        ) : null}

        {recurringModal ? (
          <ModalPopup
            setRecurringModal={setRecurringModal}
            modalData={modalData}
            subPlan={subPlan}
            isTopPlan={true}
          />
        ) : null}

        {/* <div
          style={{ marginRight: "90px" }}
          className="country-tag d-flex justify-content-between align-items-center "
        >
          <div>
            {props.match.params.alpha2 ? (
              <span
                className={`fflag fflag-${props.match.params.alpha2} ff-lg ff-round`}
              ></span>
            ) : (
              <span
                className={`${countryOrRegion == "Europe" ? "fflag-EU" : ""
                  } fflag ff-lg ff-round`}
              >
                {countryOrRegion != "Europe" ? (
                  <img
                    style={{ width: "24px", height: "24px" }}
                    className="regionLogo"
                    src={
                      countryOrRegion == "Africa"
                        ? Africa
                        : countryOrRegion == "Asia"
                          ? Asia
                          : countryOrRegion == "Australia"
                            ? Australia
                            : countryOrRegion == "Caribbean"
                              ? Caribbean
                              : countryOrRegion == "Latin America"
                                ? LatinAmerica
                                : countryOrRegion == "Balkans"
                                  ? Balkans
                                  : countryOrRegion == "Caucasus"
                                    ? Caucasus
                                    : countryOrRegion == "Middle East"
                                      ? MiddleEast
                                      : countryOrRegion == "T20 WC Region 1"
                                        ? t20WcIcon
                                        : countryOrRegion == "T20 WC Region 2"
                                          ? t20WcIcon
                                          : !props.match.params.regionId &&
                                            !props.match.params.alpha2
                                            ? World
                                            : null
                    }
                  />
                ) : (
                  ""
                )}
              </span>
            )}
          </div>
          <div style={{ overflow: "hidden" }}>
            <h1>{countryOrRegion}</h1>
            {!countryOrRegion &&
              !props.match.params.regionId &&
              !props.match.params.alpha2 && <h1>Global Plans</h1>}
          </div>
        </div> */}
        {/* <div className="plan-search-bar d-flex justify-content-between align-items-center">
          <input
            placeholder="Search by country or continent"
            type="text"
            value={userInput}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
          />
          <div className="d-flex justify-content-center align-items-center">
            <button
              className="notranslate"
              onClick={() => {
                if (suggestions[activeSuggestionIndex]?.suggestionType) {
                  handleSearch(
                    suggestions[activeSuggestionIndex]?.suggestionType,
                    suggestions[activeSuggestionIndex]?.regionId,
                    suggestions[activeSuggestionIndex]?.Alpha2,
                    suggestions[activeSuggestionIndex]?.description
                  );
                }
                // if (selectedSuggestion?.suggestionType) {
                //   handleSearch(
                //     selectedSuggestion.suggestionType,
                //     selectedSuggestion.regionId,
                //     selectedSuggestion.Alpha2,
                //     selectedSuggestion.description
                //   );
                // }
              }}
            >
              <IoSearch />
            </button>
          </div>

          {showSuggestions && suggestions.length > 0 && (
            <div className="search-suggestion-section">
              <ul>
                {suggestions.map((suggestion, index) => (
                  <li
                    key={index}
                    className={
                      index === activeSuggestionIndex ? "suggestion-active" : ""
                    }
                    ref={
                      index === activeSuggestionIndex
                        ? activeSuggestionRef
                        : null
                    }
                    onClick={() => {
                      handleSuggestionSearch(suggestion);
                      setUserInput(suggestion.description);
                      setSelectedSuggestion(suggestion);
                      setSuggestions([]);
                      setShowSuggestions(false); // Hide the suggestion list when a suggestion is selected
                    }}
                  >
                    {suggestion.suggestionType === "region" ? (
                      <span>{suggestion.description}</span>
                    ) : (
                      <span>{suggestion.description}</span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          )}
          {!isValidSuggestion && userInput && (
            <div className="search-suggestion-section">No result found</div>
          )}
        </div> */}

        {/* Cards section */}
        {/* <section className="d-flex flex-column justify-content-center align-items-center">
        <div className="card-container">
          <div className="row m-0 cards-bg">
            <div className="col-12 col-md-3 p-2">
              {selectedPlan && (
                <div
                  style={{ border: "3px solid #E58359", padding: "0" }}
                  className={`card-ticket ${selectedPlan ? "d-flex" : "d-none"
                    }`}
                >
                  <div
                    className="mb-2"
                    style={{
                      borderRadius: "15px 15px 0 0",
                      backgroundImage:
                        "linear-gradient(271deg, rgb(61, 52, 151) -1.99%, #CA5E8F 49.34%, #E68557 101.38%)",
                      padding: "4px 10px",
                      color: "#fff",
                      width: "100%",
                    }}
                  >
                    LAST RECHARGE
                  </div>
                  <div style={{ padding: "0 12px" }} className="w-100">
                    <div className="w-100" style={{ position: "relative" }}>
                      <img
                        className="stars"
                        style={{ zIndex: "-1" }}
                        src={stars}
                        alt=""
                      />
                      <h2 className="mb-2 mb-md-4" style={{ fontSize: "45px" }}>
                        {selectedPlan.data}
                      </h2>
                      <div className="d-flex flex-md-column align-items-md-start align-items-center">
                        <div>
                          <p
                            style={{
                              color: "#A0A0A0",
                              fontSize: "14px",
                              letterSpacing: "0.5px",
                            }}
                          >
                            Validity
                          </p>
                          <p
                            style={{ fontSize: "20px", fontWeight: "600" }}
                          >{`${selectedPlan.validity} Days`}</p>
                        </div>
                        <div className="mt-0 mt-md-3 ml-5 ml-md-0">
                          <p
                            style={{
                              color: "#A0A0A0",
                              fontSize: "14px",
                              letterSpacing: "0.5px",
                            }}
                          >
                            Price
                          </p>
                          <p style={{ fontSize: "20px", fontWeight: "600" }}>
                            £ {selectedPlan.price}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-100" style={{ padding: "12px" }}>
                    <button
                      onClick={() => {
                        topUpClicked(selectedPlan);
                      }}
                      className="btn notranslate"
                    >
                      TOP UP
                    </button>
                  </div>
                </div>
              )}
              <div
                className={`bg-img ${selectedPlan ? "d-none " : ""}`}
                style={{
                  backgroundImage: `url(${countryBg
                    ? countryBg
                    : "https://images.unsplash.com/photo-1451187580459-43490279c0fa?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w0NzcxNDJ8MHwxfHNlYXJjaHwzfHxnbG9iYWx8ZW58MHx8fHwxNzI2NzQ1MDY1fDA&ixlib=rb-4.0.3&q=80&w=1080"
                    })`,
                }}
              ></div>
            </div>
            <div className="col-12 col-md-3 p-2 popular-section">
              {plansFound &&
                popular.map((plan, index) => (
                  <div className="col-12 col-sm-6 col-md-12 p-0">
                    <div key={index} className="card-ticket">
                      <div className="golden-label d-flex align-items-center">
                        <img
                          className="mr-1"
                          style={{ width: "16px" }}
                          src={popularIcon}
                          alt="popular"
                        />
                        <span className="d-inline-block text-truncate number">
                          Popular #{index + 1}
                        </span>
                      </div>

                      {plan.unlimitedPlan === true ? (
                        <h2 className="mt-2 number">Unlimited</h2>
                      ) : (
                        <h2 className="mt-2 number">{plan.data}</h2>
                      )}
                      <p className="number m-0 plan-detail">{plan.planName}</p>
                      <div className="w-100 d-flex flex-wrap justify-content-around align-items-center mt-2">
                        <div className="plan-validity px-2">
                          <p className="muted-text">validity</p>
                          <p className="number">{plan.validity} Days</p>
                        </div>
                        <div className="line-seperator"></div>
                        <div className="plan-price px-2">
                          <p className="muted-text">price</p>
                          <p className="number">£ {plan.price}</p>
                        </div>
                        <div className="line-seperator second"></div>
                        <div
                          onClick={() => handleDetailsOpen(plan)}
                          className="plan-details px-2 d-flex align-items-center mt-2"
                        >
                          <BsInfoCircleFill className="mr-1" />
                          <p>Details</p>
                        </div>
                      </div>
                      {esimPlanTopUp &&
                        esimPlanTopUp.some(
                          (topUp) => topUp.esimPlan.plan.planId === plan.planId
                        ) ? (
                        <button
                          onClick={() => {
                            topUpClicked(plan, index);
                          }}
                          className="btn notranslate"
                        >
                          TOP UP
                        </button>
                      ) : (
                        <button
                          onClick={() => {
                            toggleBuy(plan, index);
                          }}
                          className="btn notranslate"
                        >
                          BUY NOW
                        </button>
                      )}
                    </div>
                  </div>
                ))}
            </div>

            <div className="col-12 col-md-3 p-2 premium-section">
              {plansFound
                ? premium.map((plan, index) => (
                  <div className="col-12 col-sm-6 col-md-12 p-0">
                    <div className="card-ticket">
                      <div className="golden-label d-flex align-items-center">
                        <img
                          className="mr-1"
                          style={{ width: "14px" }}
                          src={premiumIcon}
                          alt="premium"
                        />
                        <span className="d-inline-block text-truncate number">
                          Premium #{index + 1}
                        </span>
                      </div>
                      {plan.unlimitedPlan === true ? (
                        <h2 className="mt-2 number">Unlimited</h2>
                      ) : (
                        <h2 className="mt-2 number">{plan.data}</h2>
                      )}
                      <p className="number m-0 plan-detail">
                        {plan.planName}
                      </p>
                      <div className="w-100 d-flex flex-wrap justify-content-around align-items-center mt-2">
                        <div className="plan-validity px-2">
                          <p className="muted-text">validity</p>
                          <p className="number">{plan.validity} Days</p>
                        </div>
                        <div className="line-seperator"></div>
                        <div className="plan-price px-2">
                          <p className="muted-text">price</p>
                          <p className="number">£ {plan.price}</p>
                        </div>
                        <div className="line-seperator second"></div>
                        <div
                          onClick={() => handleDetailsOpen(plan)}
                          className="plan-details px-2 d-flex align-items-center mt-2"
                        >
                          <BsInfoCircleFill className="mr-1" />
                          <p>Details</p>
                        </div>
                      </div>
                      {esimPlanTopUp &&
                        esimPlanTopUp.some(
                          (topUp) => topUp.esimPlan.plan.planId === plan.planId
                        ) ? (
                        <button
                          className="btn notranslate"
                          onClick={() => {
                            topUpClicked(plan, index);
                          }}
                        >
                          TOP UP
                        </button>
                      ) : (
                        <button
                          className="btn notranslate"
                          onClick={() => {
                            toggleBuy(plan, index);
                          }}
                        >
                          BUY NOW
                        </button>
                      )}
                    </div>
                  </div>
                ))
                : ""}
            </div>
            <div className="col-12 col-md-3 p-2 unlimited-section">
              {plansFound
                ? unlimitedOrOther.map((plan, index) => (
                  <div className="col-12 col-sm-6 col-md-12 p-0">
                    <div className="card-ticket">
                      {plan.unlimitedPlan == true && (
                        <div className="golden-label d-flex align-items-center">
                          <img
                            className="mr-1"
                            style={{ width: "18px" }}
                            src={unlimitedIcon}
                            alt="unlimited"
                          />
                        </div>
                      )}
                      <h2 className="mt-2 number">{plan.data}</h2>
                      <p className="number m-0 plan-detail">
                        {plan.planName}
                      </p>
                      <div className="w-100 d-flex flex-wrap justify-content-around align-items-center mt-2">
                        <div className="plan-validity px-2">
                          <p className="muted-text">validity</p>
                          <p className="number">{plan.validity} Days</p>
                        </div>
                        <div className="line-seperator"></div>
                        <div className="plan-price px-2">
                          <p className="muted-text">price</p>
                          <p className="number">£ {plan.price}</p>
                        </div>
                        <div className="line-seperator second"></div>
                        <div
                          onClick={() => handleDetailsOpen(plan)}
                          className="plan-details px-2 d-flex align-items-center mt-2"
                        >
                          <BsInfoCircleFill className="mr-1" />
                          <p>Details</p>
                        </div>
                      </div>
                      {esimPlanTopUp &&
                        esimPlanTopUp.some(
                          (topUp) => topUp.esimPlan.plan.planId === plan.planId
                        ) ? (
                        <button
                          className="btn notranslate"
                          onClick={() => {
                            topUpClicked(plan, index);
                          }}
                        >
                          TOP UP
                        </button>
                      ) : (
                        <button
                          className="btn notranslate"
                          onClick={() => {
                            toggleBuy(plan, index);
                          }}
                        >
                          BUY NOW
                        </button>
                      )}
                    </div>
                  </div>
                ))
                : ""}
            </div>
          </div>
        </div>
      </section> */}
      </div>

      {/* Table section */}
      {/* <section className="d-flex flex-column justify-content-center align-items-center">
        <div id="table-section" className="table-section">
          <CustomFilterSection
            onFilterChange={handleFilterChange}
            searchText={searchText}
            handleSearchChange={handleSearchChange}
            onCheapestFilterClick={handleCheapestFilterClick}
            onBestPricePerGBFilterClick={handleBestPricePerGBFilterClick}
            onUnlimitedToggle={handleUnlimitedToggle}
            unlimitedFilter={unlimitedFilter}
            onFilterRemove={() => {
              props.match.params.regionId
                ? regionPlansAPI()
                : props.match.params.alpha2
                ? plansAPI()
                : globalPlansAPI();
            }}
            onFilterRemoveForOthers={() => {
              forUnlimitedPlans.length !== 0
                ? unlimitedToggle()
                : props.match.params.regionId
                ? regionPlansAPI()
                : props.match.params.alpha2
                ? plansAPI()
                : globalPlansAPI();
            }}
            onLongestValidityFilterClick={handleLongestValidityFilterClick}
            onLargestGBFilterClick={handleLargestGBFilterClick}
            onUnlimitedFilterToggle={unlimitedToggle}
          />
          <CSmartTable
            clickableRows
            columns={columns}
            items={filteredPlans}
            pagination
            scopedColumns={{
              avatar: (item) => (
                <td>
                  <CAvatar src={logo} />
                </td>
              ),
              show_Buy: (item, rowIndex) => {
                return (
                  <td className="py-2" style={{ textAlign: "center" }}>
                    {item.planId &&
                    esimPlanTopUp &&
                    esimPlanTopUp.some(
                      (topUp) =>
                        topUp.esimPlan.plan.planId === item.planId.planId
                    ) ? (
                      <CButton
                        className="table-view-more-btn"
                        color="light"
                        variant="outline"
                        shape="square"
                        size="sm"
                        onClick={() => {
                          topUpClicked(item.planId, rowIndex);
                        }}
                      >
                        {buy ? "TOP UP" : "TOP UP"}
                      </CButton>
                    ) : (
                      <CButton
                        className="table-view-more-btn"
                        color="light"
                        variant="outline"
                        shape="square"
                        size="sm"
                        // onClick={() => {
                        //   toggleBuy(item.planId, rowIndex);
                        // }}
                      >
                        {buy ? "Buy Now" : "Buy Now"}
                      </CButton>
                    )}
                  </td>
                );
              },
              details: (item, rowIndex) => {
                return (
                  <CCollapse visible={detailsState[rowIndex]}>
                    <CCardBody className="p-3">
                      <h4>{item.username}</h4>
                      <p className="text-muted">User since: {item.PLANNAME}</p>
                      <CButton size="sm" color="info">
                        User Settings
                      </CButton>
                      <CButton size="sm" color="danger" className="ml-1">
                        Delete
                      </CButton>
                    </CCardBody>
                  </CCollapse>
                );
              },
            }}
            tableProps={{
              className: "add-this-className",
              responsive: true,
              striped: true,
              hover: true,
            }}
            tableBodyProps={{
              className: "align-middle",
            }}
          />
        </div>
      </section> */}
      <footer style={{ marginTop: "80px" }}>
        <Footer />
      </footer>
      {/* place for AlertPopup */}

      {showVerifyPopup && (
        <AlertPopup
          status={"warning"}
          note={
            "Note* If account is verified then please sign out and sign in again."
          }
          heading={"To proceed please verify your account"}
          content={"Verification link sent to your registered email address."}
          customFunction={<ResendEmailBtn />}
          updateState={updateVarificationPopupStatus}
        />
      )}
      {showLogin && (
        <AlertPopup
          status={"warning"}
          heading={"Login required to proceed"}
          content={"To gain full access please Login"}
          customFunction={<LoginCtaBtn />}
          updateState={updateLoginPopupStatus}
        />
      )}
      {showTopup && (
        <AlertPopup
          status={"warning"}
          heading={`You currently have ${topUpPlan.esimPlan.esimPlanRecharge[0].dataRemaining} of remaining data.`}
          content={
            "Refreshing the plan will erase your remaining data. If you want to retain your data, please click Cancel and consider purchasing another data plan, or Proceed Anyway"
          }
          customFunction={<ProceedAndCancelBtn />}
          updateState={closeTopUpAlert}
        />
      )}
      {showeKycPopup && (
        <AlertPopup
          status={"warning"}
          heading={"eKYC Required for Hybrid/Min & Text Plans"}
          content={
            <>
              <p>
                To purchase Hybrid or Min Text Plans, eKYC submission is
                mandatory. Please download the app using the link below and
                complete your eKYC.
              </p>
              <div
                className="w-100 d-flex flex-wrap justify-content-center align-items-center"
                style={{ gap: "10px" }}
              >
                <a
                  target="_blank"
                  href="https://apps.apple.com/us/app/gkt-esim/id6464306833"
                >
                  <img src={appStore} alt="appStore" width={150} />
                </a>
                <a
                  target="_blank"
                  href="https://play.google.com/store/apps/details?id=com.altius.gkteSim"
                >
                  <img src={googlePlay} alt="googlePlay" width={150} />
                </a>
              </div>
            </>
          }
          note={
            "Note: You can use the same website credentials to log in to the app for a seamless experience."
          }
          customFunction={
            <button
              className="btn rounded-pill font-weight-bold text-uppercase btn-dark custom-width-btn btn-md mt-2 mb-1"
              onClick={updateKycPopupStatus}
            >
              <font>Close</font>
            </button>
          }
          updateState={updateKycPopupStatus}
        />
      )}

      <CustomModal
        width={768}
        isOpen={detailsOpen}
        onClose={handleDetailsClose}
        customPadding={70}
      >
        <div className="normal-custom-modal">
          <h3 className="title mb-0">{currentDetails.planName}</h3>
          <ul className="m-0">
            {/* <li className="w-100 d-flex justify-content-between align-items-center py-2">
              <p className="m-0">Plan Name</p>
              <p className="m-0">{currentDetails.planName}</p>
            </li> */}
            <li className="w-100 d-flex justify-content-between align-items-center py-2">
              <p className="m-0">Plan Type</p>
              <p className="m-0">
                {currentDetails.bundleType != null &&
                  currentDetails.bundleType.bundleTypeDesc}
              </p>
            </li>
            <li className="w-100 d-flex justify-content-between align-items-center py-2">
              <p className="m-0">
                {currentDetails.bundleType != null &&
                  currentDetails.bundleType.bundleTypeId == RECURRING_BUNDLE_ID
                  ? "Renewal"
                  : "Top Up"}
              </p>
              <p className="m-0">
                {currentDetails.topupAvailable == 1
                  ? "Available"
                  : "Unavailable"}
              </p>
            </li>
            {currentDetails.planType &&
              currentDetails.planType.planTypeId != 3 ? (
              <li className="w-100 d-flex justify-content-between align-items-center py-2">
                <p className="m-0 col-4 col-md-6 p-0">Coverage</p>
                {currentDetails.region ? (
                  <div
                    // onClick={() => {
                    //   openModalDropdown(currentDetails.regionId);
                    // }}
                    className="col-8 col-md-6 p-0 countries-label-dropdown d-flex justify-content-end align-items-center position-relative"
                  >
                    {currentDetails.region ? (
                      <p
                        style={{
                          fontSize: 14,
                          fontWeight: 500,
                          color: "#fff",
                          textAlign: "right",
                        }}
                        className="m-0"
                      >
                        {currentDetails.region.regionDescription}
                      </p>
                    ) : (
                      <p
                        style={{
                          fontSize: 14,
                          fontWeight: 500,
                          color: "#fff",
                          textAlign: "right",
                        }}
                        className="m-0"
                      >
                        Country
                      </p>
                    )}
                  </div>
                ) : (
                  <div className="col-8 col-md-6 p-0">
                    {currentDetails.planCountry &&
                      currentDetails.planCountry.length > 0 ? (
                      <p
                        style={{
                          fontSize: 14,
                          fontWeight: 500,
                          color: "#fff",
                          textAlign: "right",
                        }}
                        className="m-0"
                      >
                        {currentDetails.planCountry
                          .map((country) => country.countryDescription)
                          .join(", ")}
                        {" - "}
                        {currentDetails.planCountry[0].planCountryNetwork
                          ? currentDetails.planCountry[0].planCountryNetwork.join(
                            ", "
                          )
                          : ""}
                      </p>
                    ) : (
                      <p
                        style={{
                          fontSize: 14,
                          fontWeight: 500,
                          color: "#fff",
                          textAlign: "right",
                        }}
                        className="m-0"
                      >
                        No coverage information available
                      </p>
                    )}
                  </div>
                )}
              </li>
            ) : (
              <li className="w-100 d-flex justify-content-between align-items-center py-2">
                <p className="m-0">Coverage</p>
                <p style={{ fontSize: 22, color: "#fff" }} className="m-0">
                  Global
                </p>
              </li>
            )}
            {currentDetails?.planType?.planTypeId != 1 &&
              currentDetails?.planCountry?.length > 0 &&
              currentDetails.planCountry.filter((c) => c.sanction) != "" &&
              currentDetails?.vendor?.vendorId == NETWORK3_VENDOR && (
                <li className="w-100 d-flex justify-content-between align-items-center py-2">
                  <p className="m-0">{"Sanctions Country"}</p>
                  <p className="m-0">
                    {currentDetails?.planCountry?.length > 0 &&
                      currentDetails.planCountry
                        .filter((c) => c.sanction)
                        .map((country) => country.countryDescription)
                        .join(", ")}
                  </p>
                </li>
              )}
            {currentDetails?.planType?.planTypeId != 1 &&
              currentDetails?.planCountry?.length > 0 &&
              currentDetails.planCountry.filter((c) => c.sanction) != "" &&
              currentDetails?.vendor?.vendorId == NETWORK3_VENDOR && (
                <li
                  className="w-100 d-flex align-items-center py-2"
                  style={{ gap: "4px" }}
                >
                  <BsInfoCircleFill
                    style={{
                      fontSize: 14,
                    }}
                  />
                  <p style={{ fontSize: "12px" }} className="m-0">
                    {
                      "Please note, no services (Data, Calls & Text) will be accessible in the sanctioned countries or regions."
                    }
                  </p>
                </li>
              )}
            {/* {currentDetails.planCategory != null && (currentDetails.planCategory.planCategoryId == DATA_CALLS_SMS || currentDetails.planCategory.planCategoryId == DATA_ONLY) &&
              <li className="w-100 d-flex justify-content-between align-items-center py-2">
                <p className="m-0">Maximum data</p>
                <p className="m-0">{currentDetails.data}</p>
              </li>}
            {currentDetails.planCategory != null && (currentDetails.planCategory.planCategoryId == DATA_CALLS_SMS || currentDetails.planCategory.planCategoryId == CALLS_AND_SMS) &&
              <li className="w-100 d-flex justify-content-between align-items-center py-2">
                <p className="m-0">Maximum minutes</p>
                <p className="m-0">{currentDetails.call}</p>
              </li>}
            {currentDetails.planCategory != null && (currentDetails.planCategory.planCategoryId == DATA_CALLS_SMS || currentDetails.planCategory.planCategoryId == CALLS_AND_SMS) &&
              <li className="w-100 d-flex justify-content-between align-items-center py-2">
                <p className="m-0">Maximum text</p>
                <p className="m-0">{currentDetails.text}</p>
              </li>} */}
          </ul>
          <div className="network-overide-table-section mt-2">
            <table className="table network-overide-table notranslate">
              <thead>
                <tr>
                  <th className="table-network-header first text-center">
                    Type
                  </th>
                  <th className="table-network-header second text-center">
                    Services
                  </th>
                  <th className="table-network-header third">Definition</th>
                  <th className="table-network-header last text-center">
                    Coverage
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item, index) => (
                  <tr key={index}>
                    <td className="table-network-cell text-center">
                      {item.type}
                    </td>
                    <td className="table-network-cell text-center">
                      {item.service}
                    </td>
                    <td className="table-network-cell">
                      <div
                        className="d-flex justify-content-between align-items-center"
                        style={{ gap: "6px" }}
                      >
                        <div>
                          <p className="m-0">{item.definition}</p>
                        </div>
                        <div>
                          <Tooltip style={{ fontSize: 12 }} text={item.example}>
                            <BsInfoCircleFill
                              style={{
                                fontSize: 14,
                              }}
                            />
                          </Tooltip>
                        </div>
                      </div>
                    </td>
                    <td className="table-network-cell center text-center">
                      {item.coverage?.length > 0 ? (
                        <div
                          onClick={() => {
                            openCoverageDropdownForDetails(
                              index,
                              item.coverage
                            );
                          }}
                          className="countries-label-dropdown d-flex justify-content-center align-items-center"
                          style={{ cursor: "pointer" }}
                        >
                          {item.coverage?.length > 1 ? (
                            <>
                              <span class="lightText">
                                {item.coverage?.length} Countries
                              </span>
                              <IoMdArrowDropdown />
                            </>
                          ) : (
                            <p className="m-0">
                              {item.coverage[0].countryDescription}
                            </p>
                          )}
                        </div>
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </CustomModal>
      {/* Details dropdown modal */}
      {isCoverageDropdownOpenForDetails ? (
        <div className="dropdowns-modal" style={{ zIndex: "99999999" }}>
          <CoverageDropdownForDetails
            planCountry={filteredData}
            index={indexForDetailsDropdown}
          />
        </div>
      ) : null}
      <ContactUsForm />
      {isLoading && <Loader />}
      {/* Bg gradient Images  */}
      {/* <div className="left-top-grad"></div>
      <div className="right-top-grad"></div>
      <div className="left-bottom-grad"></div> */}
      {/* <img className="planBgLeft" src={planBgLeft} alt="" />
      <img className="planBgRight" src={planBgRight} alt="" /> */}
    </div>
  );
};
export default Plans;
const renderTab = (tab) => {
  return <button className={`tabs__button notranslate`}>{tab}</button>;
};
